// Auto-generated from Neon Postgres - 2026-07-01T09:22:06.688Z
import type { Category, Listing, Review } from '../types';

export const seedCategories: Category[] = [
  { id: "builders", name: "Boat Builders & Repair", icon: "🛠️", slug: "boat-builders-repair" },
  { id: "chandlers", name: "Marine Chandlers", icon: "🔧", slug: "marine-chandlers" },
  { id: "charters", name: "Boat Charters", icon: "⛵", slug: "boat-charters" },
  { id: "diving", name: "Diving & Water Sports", icon: "🤿", slug: "diving-water-sports" },
  { id: "electronics", name: "Marine Electronics", icon: "📡", slug: "marine-electronics" },
  { id: "engineering", name: "Marine Engineering", icon: "⚙️", slug: "marine-engineering" },
  { id: "fishing", name: "Fishing Charters", icon: "🎣", slug: "fishing-charters" },
  { id: "forsale", name: "Boats for Sale", icon: "🏷️", slug: "boats-for-sale" },
  { id: "fuel", name: "Fuel & Bunkering", icon: "⛽", slug: "fuel-bunkering" },
  { id: "insurance", name: "Marine Insurance", icon: "🛡️", slug: "marine-insurance" },
  { id: "marinas", name: "Marinas & Berths", icon: "⚓", slug: "marinas-berths" },
  { id: "ramps", name: "Boat Ramps & Launches", icon: "🛶", slug: "boat-ramps-launches" },
  { id: "rentals", name: "Boat Rentals", icon: "🚤", slug: "boat-rentals" },
  { id: "sailmakers", name: "Sailmakers & Canvas", icon: "🧵", slug: "sailmakers-canvas" },
  { id: "training", name: "Training & Courses", icon: "🏫", slug: "training-courses" },
  { id: "transport", name: "Boat Transport", icon: "🚚", slug: "boat-transport" },
];

export const seedListings: Listing[] = [
  {
    id: 1,
    title: "Hauraki Gulf Sailing Charters",
    description: "Explore the stunning Hauraki Gulf with our experienced crew. We offer day charters, sunset sails, and multi-day trips around the islands. Our 42ft yacht is fully equipped and surveyed for up to 12 passengers. With over 15 years of experience, we know the best anchorages, fishing spots and hidden bays.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0142",
    email: "info@haurakicharters.co.nz",
    website: "https://example.com",
    services: ["Skippered charters","Bareboat charters","Sunset sails","Corporate events","Overnight trips"],
    image_url: "https://www.catamarancharters.co.nz/wp-content/themes/cruczar/images/cruczar-sailing.jpg",
    badge: "featured",
    rating: 4.9,
    reviews_count: 127,
  },
  {
    id: 2,
    title: "Bayswater Marine Supply",
    description: "Your one-stop marine supply store on Auckland's North Shore. We stock everything from anchors to zinc anodes, with expert advice thrown in for free. Family-owned and operated for over 25 years, we know what Kiwi boaties need because we're boaties ourselves.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0188",
    email: "sales@bayswatermarine.co.nz",
    website: "https://example.com",
    services: ["Chandlery","Safety equipment","Paint & antifoul","Rope & rigging","Hardware"],
    image_url: "https://img.boatdeckcrm.com.au/media/20240920100831-ada92b5636a92d05a70be9f24781739ec612b1073a300fb1c8ffb179506713a9/DSC08554_medium.jpg",
    badge: "premium",
    rating: 4.8,
    reviews_count: 89,
  },
  {
    id: 3,
    title: "Bay of Islands Fishing Adventures",
    description: "New Zealand's premier fishing charter in the Bay of Islands. Target snapper, kingfish, marlin and more. Our 8m Stabicraft is fully surveyed and equipped with top-tier electronics. Trips depart from Paihia and Russell daily. Bait, tackle and quality gear all included - just bring your sunhat.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 5,
    region_name: "Far North",
    phone: "+64 9 555 0203",
    email: "skipper@boifishing.co.nz",
    website: "https://example.com",
    services: ["Deep sea fishing","Game fishing","Half-day trips","Full-day charters","Bait & tackle provided"],
    image_url: "https://fishingchartersbayofislands.com/wp-content/uploads/2026/05/Marlin-1024x536.jpg",
    badge: "featured",
    rating: 5,
    reviews_count: 204,
  },
  {
    id: 4,
    title: "Whangarei Boatyard & Haulout",
    description: "Full-service boatyard in Whangarei with a 50-tonne travel lift. We handle vessels up to 24m for haulout, antifoul, repairs and refits. Our team includes shipwrights, engineers and painters with decades of combined experience. Competitive rates and quality workmanship guaranteed.",
    category_id: "builders",
    category_name: "Boat Builders & Repair",
    region_id: 18,
    region_name: "Whangarei",
    phone: "+64 9 555 0317",
    email: "yard@whangareiboatyard.co.nz",
    website: "",
    services: ["Haulout","Antifoul","Hull repair","Gelcoat","Mechanical service"],
    image_url: "https://www.dockland5.co.nz/wp-content/uploads/2024/09/Dockland-5-15.jpg",
    badge: "new",
    rating: 4.7,
    reviews_count: 56,
  },
  {
    id: 5,
    title: "Navicom Marine Electronics",
    description: "Authorised dealer and service centre for Garmin, Raymarine and Furuno. We install, repair and upgrade marine electronics across the Bay of Plenty. Factory-trained technicians, mobile service available. Same-day repairs for critical equipment when possible.",
    category_id: "electronics",
    category_name: "Marine Electronics",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "+64 7 555 0441",
    email: "service@navicom.co.nz",
    website: "https://example.com",
    services: ["GPS & chartplotters","VHF radios","Autopilots","Radar","Fish finders","Installation & repair"],
    image_url: "https://asset.turboweb.co.nz/7/cache/file/5e39e9b8c2373/6b0c5dfb81d823d6fde29242f6e92a9c/Navcom%20Electronics%20Marine%20Electronics%20Otago%20and%20Southland.webp",
    badge: "premium",
    rating: 4.8,
    reviews_count: 42,
  },
  {
    id: 6,
    title: "Poor Knights Dive Centre",
    description: "Dive the world-renowned Poor Knights Islands Marine Reserve. Jacques Cousteau rated it one of the top 10 dive sites in the world. We run daily trips with our custom dive boat, catering to all experience levels. PADI courses from Open Water to Divemaster. Full gear hire available.",
    category_id: "diving",
    category_name: "Diving & Water Sports",
    region_id: 11,
    region_name: "Northland",
    phone: "+64 9 555 0566",
    email: "dive@poorknights.co.nz",
    website: "https://example.com",
    services: ["Dive trips","Dive courses","Equipment hire","Snorkelling","PADI certified"],
    image_url: "https://diving.co.nz/wp-content/themes/diving-tutukaka/images/poor-knights-diving.jpg",
    badge: "featured",
    rating: 4.9,
    reviews_count: 178,
  },
  {
    id: 7,
    title: "Marlborough Sounds Cruise Co",
    description: "Discover the sheltered waterways of the Marlborough Sounds. Our 15m catamaran offers day cruises and multi-day charters exploring Queen Charlotte and Pelorus Sounds. We specialise in wildlife, wine and wilderness - dolphins, penguins, gannets and world-class Sauvignon Blanc all in one trip.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 9,
    region_name: "Marlborough",
    phone: "+64 3 555 0712",
    email: "info@mscruise.co.nz",
    website: "https://example.com",
    services: ["Day cruises","Multi-day charters","Wine & food tours","Wildlife viewing","Kayaking"],
    image_url: "https://cdn.prod.website-files.com/664aa88f53af49a4266a7810/6836622438ac3747f8661d3f_Hero%20Pic%20(1).jpg",
    badge: "premium",
    rating: 4.9,
    reviews_count: 93,
  },
  {
    id: 8,
    title: "Rotorua Lake Boat Hire",
    description: "Self-drive boat rentals on Lakes Rotorua and Rotoiti. No licence required for our 4m tinnies - just a quick safety briefing and you're away. Perfect for fishing, exploring or just enjoying the lake. Lifejackets and safety gear all provided. Open 7 days, weather permitting.",
    category_id: "rentals",
    category_name: "Boat Rentals",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "+64 7 555 0834",
    email: "rent@lakeboats.co.nz",
    website: "",
    services: ["Tinnie hire","Pontoon boats","Kayak hire","Stand-up paddleboards","Fishing gear hire"],
    image_url: "https://img.getmyboat.com/images/eb9d7595-8f8c-464c-a4e9-df66188741f8/-processed.jpg?",
    badge: "",
    rating: 4.6,
    reviews_count: 67,
  },
  {
    id: 9,
    title: "Westhaven Marina",
    description: "New Zealand's largest marina with 1,800 berths. Located in the heart of Auckland's waterfront, Westhaven offers berth rentals, hard stand, boatyard facilities, 24/7 security and a vibrant community of boaties. Close to the city with excellent transport links. Waitlist available for permanent berths.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0922",
    email: "office@westhavenmarina.co.nz",
    website: "https://example.com",
    services: ["Berth rentals","Hard stand","Boatyard","Fuel dock","Pump-out facility","Security 24/7"],
    image_url: "https://marinelink.co.nz/images/listings/westhaven-marina-img.png",
    badge: "featured",
    rating: 4.7,
    reviews_count: 145,
  },
  {
    id: 10,
    title: "Kiwi Boat Brokers",
    description: "New Zealand's trusted boat brokerage for over 20 years. We list yachts, launches, runabouts and trailer boats. Full survey and mechanical inspection service. Finance and insurance arranged. Whether buying or selling, we make the process smooth and stress-free.",
    category_id: "forsale",
    category_name: "Boats for Sale",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0356",
    email: "sales@kiwiboatbrokers.co.nz",
    website: "https://example.com",
    services: ["New boats","Used boats","Yacht brokerage","Motor launches","Trailers","Finance available"],
    image_url: "https://cloudcdn.nz/_orakeimarine_/assets/uploads/2015/02/Prestige_520-Jean-Marie_LIOT5-e1538364521908.jpg",
    badge: "premium",
    rating: 4.8,
    reviews_count: 78,
  },
  {
    id: 11,
    title: "Diesel Marine Engineering Ltd",
    description: "Specialist marine diesel engineers servicing the South Island. Authorised service agents for Yanmar, Volvo Penta and Nanni. From routine servicing to full repowers, we keep your engine running right. Mobile service across Canterbury and beyond. 24/7 callout for commercial operators.",
    category_id: "engineering",
    category_name: "Marine Engineering",
    region_id: 3,
    region_name: "Canterbury",
    phone: "+64 3 555 0178",
    email: "service@dieselmarine.co.nz",
    website: "",
    services: ["Engine servicing","Repowers","Saildrives","Shafts & props","On-water service"],
    image_url: "https://marinelink.co.nz/images/listings/listing-11.png",
    badge: "",
    rating: 4.9,
    reviews_count: 51,
  },
  {
    id: 12,
    title: "Auckland Sail & Canvas",
    description: "Full-service sail loft and canvas workshop. We build new sails, repair old ones, and craft custom covers, biminis and upholstery. Over 30 years of sailmaking experience. Free quotes and advice. Pick-up and delivery available across Auckland.",
    category_id: "sailmakers",
    category_name: "Sailmakers & Canvas",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0455",
    email: "info@aksailcanvas.co.nz",
    website: "",
    services: ["New sails","Sail repair","Covers & biminis","Upholstery","Spinnakers"],
    image_url: "https://sailmakers.co.nz/wp-content/uploads/2020/01/sailmakers-auckland.jpg",
    badge: "",
    rating: 4.7,
    reviews_count: 34,
  },
  {
    id: 101,
    title: "Savoy Charters",
    description: "Auckland's most in-demand luxury yacht charter, established in 2014. Savoy offers skippered day trips and liveaboard adventures across the Hauraki Gulf, from Kawau Island to Great Barrier. Their knowledgeable crew tailor every voyage - corporate events, sunset cruises, or multi-day fishing expeditions - with gourmet catering and premium service. Departing from Viaduct Marina, right in the heart of Auckland.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 953 0299",
    email: "info@charters.co.nz",
    website: "https://www.savoy.co.nz/",
    services: ["Luxury private charters","Corporate events","Sunset cruises","Fishing trips","Skippered liveaboard"],
    image_url: "https://static.wixstatic.com/media/91fcad_ccd6f7f02a91431997be7e9bfb59b606~mv2.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 102,
    title: "Charterlink Bareboat Yacht Charters",
    description: "The largest bareboat yacht charter company in Auckland, operating from Bayswater Marina on the North Shore. Charterlink offers a fleet of cruising yachts from 30 to 46 feet for self-sail adventures across the Hauraki Gulf, Coromandel, and Bay of Islands. With decades of experience, they provide everything needed for a safe and memorable sailing holiday - just bring your skippering skills and a sense of adventure.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 445 7114",
    email: "charter@charterlink.co.nz",
    website: "https://www.charterlink.co.nz/",
    services: ["Bareboat yacht charter","Skippered charters","Sailing holidays","Shared ownership schemes"],
    image_url: "https://www.charterlink.co.nz/images/hauraki_gulf_bareboat_charters/2/thumb_vb_port_quarter_under_sail_2019.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 103,
    title: "Catamaran Charters NZ",
    description: "Sail the Hauraki Gulf aboard Cruczar, a 38ft Tennant Sienna sailing catamaran based in Auckland. Owner-skipper Warren Brown - a NauticEd qualified Level V Captain - offers both bareboat and skippered charters for up to two families. Explore Rangitoto, Tiritiri Matangi, Kawau, and Waiheke Island, or venture further to Great Barrier for fishing and wildlife encounters. Comfortable, roomy, and perfect for memorable family adventures.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 27 975 1731",
    email: "info@catamarancharters.co.nz",
    website: "https://www.catamarancharters.co.nz/",
    services: ["Bareboat catamaran charter","Skippered charters","Hauraki Gulf sailing","Fishing","Snorkelling"],
    image_url: "https://www.catamarancharters.co.nz/wp-content/uploads/2019/02/boat.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 104,
    title: "Explore Group",
    description: "A leading marine tourism operator since 2000, Explore Group offers Auckland harbour sailing experiences aboard purpose-built yachts including former America's Cup vessels. With a diverse fleet and departures from Viaduct Harbour, they provide everything from 90-minute harbour sails to full private charters and island adventures. Also operating in the Bay of Islands with dolphin watching and coastal tours.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 359 5987",
    email: "info@exploregroup.co.nz",
    website: "https://www.exploregroup.co.nz/",
    services: ["America's Cup sailing","Harbour sailing cruises","Wildlife cruises","Private charters","Bay of Islands tours"],
    image_url: "https://www.exploregroup.co.nz/media/bthdhfyq/02-sail-up-city-in-background.jpg?width=440&height=440&v=1dbda1a18edbcc0",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 105,
    title: "Auckland Charter Boats",
    description: "Auckland's most comprehensive charter boat brokerage, offering access to over 50 charter boats for any occasion. From luxury superyacht events to budget-friendly party cruises, Auckland Charter Boats matches you with the perfect vessel. Their range covers corporate functions, bucks parties, birthdays, fishing trips, and whale watching - all departing from Auckland's vibrant waterfront.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 482 2078",
    email: "info@charterboatbroker.com",
    website: "https://www.aucklandcharterboats.com/",
    services: ["Corporate cruises","Party cruises","Weddings","Sunset cruises","Waiheke transfers","Fishing trips"],
    image_url: "https://www.aucklandcharterboats.com/i/images/home/about_us.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 106,
    title: "Ultimate Charters",
    description: "Auckland's premier fishing charter specialist, offering private group fishing trips for 10 to 40 people. With experienced skippers and well-equipped vessels, Ultimate Charters provides 6 to 8 hour fishing adventures targeting snapper, kingfish and more in the Hauraki Gulf. Highly rated by previous guests for their knowledgeable crew, great equipment, and commitment to putting guests on the fish.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 800 262 844",
    email: "bookings@ultimatecharters.co.nz",
    website: "https://www.ultimatecharters.co.nz/",
    services: ["Fishing charters","Harbour cruises","Party boat hire","Private group charters"],
    image_url: "https://images.squarespace-cdn.com/content/5e4784d807eced29ee3c20cf/1619103742288-4EZ8TJ1PMYQM5PI46BJF/fishing-charters-auckland.jpg?format=1500w&content-type=image%2Fjpeg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 107,
    title: "Auckland Whale & Dolphin Safari",
    description: "Auckland's award-winning whale and dolphin watching charter operator, cruising the Hauraki Gulf aboard the vessel Dolphin Explorer. They offer private charters for up to 100 guests - perfect for corporate functions, staff Christmas parties, and community fundraising events. Their conservation-focused cruises showcase the incredible marine wildlife of the gulf, with expert commentary from knowledgeable crew.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 357 6022",
    email: "charters@awads.co.nz",
    website: "https://whalewatchingauckland.com/",
    services: ["Wildlife watching charters","Corporate functions","Fundraising charters","Harbour cruises"],
    image_url: "https://marinelink.co.nz/images/listings/listing-107.png",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 108,
    title: "She's a Lady Sailing Adventures",
    description: "A boutique day sailing experience in the Bay of Islands aboard the yacht She's a Lady. Skippered by experienced ocean sailor and RYA Yachtmaster Instructor Glen Caulton, this personalised sailing adventure departs Paihia at 9am, returning around 4pm. Guests can help helm, troll for fish, enjoy a healthy beach lunch, snorkel, kayak, and explore island walks - all for one of the best-value day sail prices in the bay.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 0,
    region_name: "",
    phone: "+64 800 724 584",
    email: "",
    website: "https://www.sailingbayofislands.com/",
    services: ["Day sailing charters","Private charters","Sunset tours","Snorkelling","Kayaking","Island stops"],
    image_url: "https://www.sailingbayofislands.com/wp-content/uploads/2018/02/shes-a-lady-in-bay.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 109,
    title: "Phantom Sailing Charters",
    description: "Bay of Islands' most experienced day sailing operator, running for over 30 years aboard Phantom - a custom C&C 50 ex-racing yacht. Owners Rick and Robin take a maximum of 10 guests for a deeply personal sailing experience from Russell. Guests enjoy swimming, snorkelling, island walks, and what Lonely Planet called 'the best lunch in the bay'. Operating October to April each year.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 0,
    region_name: "",
    phone: "+64 274 752 411",
    email: "yachtphantom@gmail.com",
    website: "https://www.phantomsailingbayofislands.com/",
    services: ["Day sailing charters","Private charters","Snorkelling","Island walks","Wildlife viewing"],
    image_url: "https://www.phantomsailingbayofislands.com/wp-content/uploads/2022/12/couple-on-yacht.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 110,
    title: "Great Escape Yacht Charters",
    description: "Bay of Islands' go-to for affordable bareboat yacht charters and sailing instruction, based at Opua Marina. Great Escape offers a fleet of well-maintained kiwi-designed yachts from 20 to 31 feet, perfect for couples and small families exploring the sheltered waters of the Bay of Islands. Their sailing school provides international qualifications, from beginner courses to advanced flotilla adventures.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 0,
    region_name: "",
    phone: "+64 9 402 7143",
    email: "sail@greatescape.co.nz",
    website: "https://www.greatescape.co.nz/",
    services: ["Bareboat yacht charter","Sailing school","Learn-to-sail courses","Sailing holidays","Flotilla adventures"],
    image_url: "https://www.greatescape.co.nz/wp-content/themes/en_greatescape/images/sailing-holidays-for-sailors.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 111,
    title: "Bayscapes Charters",
    description: "A luxury catamaran sailing experience in the Bay of Islands, operated by local skippers Brad and Monique from Paihia. Their 40ft catamaran offers both shared day escapes and private charters, with departures from Paihia, Russell, or Waitangi Wharf. Guests enjoy paddleboarding, snorkelling, island walks, and packed lunch while taking in the stunning scenery of the Bay of Islands.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 0,
    region_name: "",
    phone: "+64 220 964 008",
    email: "info@bayscapescharters.co.nz",
    website: "https://bayscapescharters.co.nz/",
    services: ["Shared sailing charters","Private catamaran charters","Snorkelling","Stand-up paddleboarding","Island stops"],
    image_url: "https://bayscapescharters.co.nz/wp-content/uploads/2026/03/boat-5-1024x768.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 112,
    title: "Abyss Charters",
    description: "A modern private charter operation in the Bay of Islands, aboard a purpose-built 10m Makaira boat designed by a qualified naval architect for NZ conditions. Skippered by Franco, a Maritime NZ-certified skipper with a lifetime of boating experience, Abyss Charters offers fishing adventures and scenic cruises from Paihia, Opua, or Russell. The vessel features modern electronics, live bait tank, galley, and even barista coffee.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 0,
    region_name: "",
    phone: "",
    email: "",
    website: "https://abysscharters.co.nz/",
    services: ["Private boat charters","Fishing trips","Wildlife tours","Hole in the Rock cruises"],
    image_url: "https://abysscharters.co.nz/wp-content/uploads/2024/06/Hole-in-the-Rock-v1.webp",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 113,
    title: "Compass Charters",
    description: "Marlborough Sounds' established charter operator, offering a fleet of yachts, launches, and runabouts for bareboat hire from Picton. Compass Charters provides the freedom to explore Queen Charlotte Sound at your own pace - stay aboard or ashore, fish, dive, or simply cruise the sheltered waterways. Day charters available from $900, with options to suit every group size and budget.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 9,
    region_name: "Marlborough",
    phone: "+64 3 573 8332",
    email: "",
    website: "https://www.compasscharters.co.nz/",
    services: ["Bareboat yacht charter","Launch charter","Runabout hire","Day charters","Queen Charlotte Sound cruising"],
    image_url: "https://lirp.cdn-website.com/0f04014d/dms3rep/multi/opt/sunset+cropped+1200x627-1920w.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 114,
    title: "Pelorus Tours",
    description: "A family-run charter business operating in the spectacular Marlborough Sounds since the 1980s. Gary and Ellen Orchard offer personalised charter boat services from Kenepuru Sound, including eco tours, fishing and diving trips, water transport, and boat storage. All services are priced on enquiry and tailored to individual needs, ensuring a truly customised Marlborough Sounds experience.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 9,
    region_name: "Marlborough",
    phone: "+64 3 573 4203",
    email: "",
    website: "https://www.pelorustours.co.nz/",
    services: ["Charter boats","Eco tours","Fishing trips","Diving charters","Water transport"],
    image_url: "https://www.pelorustours.co.nz/images/home/home_charter_boat.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 115,
    title: "Sweet Georgia Cruising",
    description: "Wellington's most loved charter boat, cruising the beautiful Wellington Harbour and Marlborough Sounds. Sweet Georgia accommodates up to 75 guests with full licensing, premium food menus, and local wines and craft beer. Perfect for corporate Christmas parties, conferences, team building, weddings, or sunset cruises - she's fully self-contained for extended liveaboard operations and multi-day adventures.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 16,
    region_name: "Wellington",
    phone: "+64 27 309 3413",
    email: "info@sweetgeorgiacruising.com",
    website: "https://www.sweetgeorgiacruising.com/",
    services: ["Harbour cruises","Corporate events","Weddings","Sunset cruises","Fishing charters","Marlborough Sounds cruises"],
    image_url: "https://static.wixstatic.com/media/fcb93c_140d57ca3aa34b1090d2782f773353f0~mv2_d_4894_2753_s_4_2.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 116,
    title: "Harbour City Charters - Mission Hills",
    description: "Wellington's leading luxury motor yacht charter aboard Mission Hills, a 72ft vessel perfect for any occasion. Accommodating up to 36 guests, she offers morning, afternoon, and evening cruises or fully customised day trips on Wellington Harbour. From corporate functions to wedding parties and fine dining cruises, the hospitable crew creates unforgettable experiences with stunning harbour views.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 16,
    region_name: "Wellington",
    phone: "+64 21 958 855",
    email: "",
    website: "https://harbourcitycharters.co.nz/",
    services: ["Luxury motor yacht charter","Corporate functions","Wedding parties","Island day trips","Fine dining cruises"],
    image_url: "https://marinelink.co.nz/images/listings/listing-116.png",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 117,
    title: "Megisti Sailing Charters",
    description: "Wellington's favourite sailing catamaran, Megisti is a 12.6-metre vessel surveyed for 20 passengers plus crew. Offering 75-minute public harbour sails and private charters for swimming, barbecues, and fully stocked bar cruises. Keep an eye out for little blue penguins, dolphins, and occasional whales. Departing from Queens Wharf, it's a unique way to experience Wellington from the water.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 16,
    region_name: "Wellington",
    phone: "",
    email: "",
    website: "https://www.megisti.co.nz/",
    services: ["Harbour sailing","Private charters","Barbecue charters","Licensed bar cruises","Wildlife watching"],
    image_url: "https://images.squarespace-cdn.com/content/v1/5d55ef804e09a5000190f3df/1566183004384-2I41ZGQURL4OEQSDD4V8/corporate-events.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 118,
    title: "Windborne Sailing Charters",
    description: "A classic 1928 gaff-rigged topsail schooner sailing from Whitianga Wharf on the Coromandel Peninsula. Captain Avon brings over 35 years of sailing experience to every voyage, exploring Cathedral Cove, Hahei Marine Reserve, and Mercury Islands. Windborne offers shared day trips, romantic sunset cruises, and private charters - a truly unique heritage sailing experience along Coromandel's stunning coastline.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 4,
    region_name: "Coromandel",
    phone: "+64 274 752 411",
    email: "avon@windborne.co.nz",
    website: "https://windborne.co.nz/",
    services: ["Day sailing charters","Private charters","Sunset cruises","Great Mercury Island trips","Snorkelling","Swimming"],
    image_url: "https://windborne.co.nz/wp-content/uploads/2025/10/windborne-84.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 119,
    title: "Boom Sailing",
    description: "A small kiwi company offering action-packed yet chilled-out sailing adventures around Mercury Bay and Cathedral Cove. Boom Sailing operates racing-grade catamarans from Whitianga, with 3.5-hour shared trips twice daily and private charters from 3 to 8 hours. Their experienced crew tailor each journey - swim, snorkel, explore remote beaches, or simply sail the day away. Affordable luxury on the Coromandel coast.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 4,
    region_name: "Coromandel",
    phone: "+64 22 327 8510",
    email: "boomsailing@gmail.com",
    website: "https://boomsailing.co.nz/",
    services: ["Shared sailing trips","Private charters","Cathedral Cove sails","Snorkelling","Wildlife viewing"],
    image_url: "https://images.squarespace-cdn.com/content/561c83cce4b01e97b62a5c77/1444710649000-9WYMHXP5P9NT0049Z19M/Boom%21+Sailing6.png?content-type=image%2Fpng",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 120,
    title: "Tauranga Marine Charters",
    description: "Tauranga's longest-running fishing charter operation, with the MV Manutere taking anglers out for over 40 years. A purpose-built charter fishing vessel with plenty of walk-around space, perfect for individuals, families, or groups. Offering public trips, private charters, and specialised reef and hapuka fishing - targeting snapper, tarakihi, kingfish, and deep-water species year-round from Tauranga in the beautiful Bay of Plenty.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "",
    email: "",
    website: "https://www.taurangamarinecharters.co.nz/",
    services: ["Public fishing trips","Private fishing charters","Reef fishing","Hapuka fishing","Kingfish jigging","Extended trips"],
    image_url: "https://pictures.rs-cdn.com/CF-a10d2c72-1fe3-477c-add2-5d8683697178/width=1200,height=650,fit=cover,gravity=0.50x0.10,sharpen=0.20/144424bb2f9d23c40bf7e28a35858eb8.jpg",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 121,
    title: "Classic Boat Charter",
    description: "Sail aboard Arcturus, a beautifully restored 1930 classic schooner with a rich history - once sailed by General George Patton. Based at Marsden Cove in Whangarei, Classic Boat Charter offers private sailing experiences for birthdays, anniversaries, and special celebrations. Guests can sit back and enjoy the scenery or help sail the vessel. A truly unique heritage sailing experience on Whangarei Harbour.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 18,
    region_name: "Whangarei",
    phone: "",
    email: "",
    website: "https://www.classicboatcharter.com/",
    services: ["Private yacht charter","Day sailing","Sunset cruises","Special occasions","Whangarei Harbour sailing"],
    image_url: "https://www.classicboatcharter.com/wp-content/uploads/sites/3169/2019/08/P1020180.jpg?w=700&h=700&zoom=2",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 122,
    title: "Black Cat Cruises",
    description: "New Zealand's pioneering eco-tourism operator since 1985, based in Akaroa on Banks Peninsula. Black Cat Cruises offers award-winning nature cruises and dolphin swimming experiences with the rare Hector's Dolphin. Their vessel Canterbury Cat departs from Akaroa Main Wharf for 2-hour cruises exploring volcanic cliffs, sea caves, and wildlife including penguins, fur seals, and seabirds. Private charters also available.",
    category_id: "charters",
    category_name: "Boat Charters",
    region_id: 3,
    region_name: "Canterbury",
    phone: "+64 3 304 7641",
    email: "akaroa@blackcat.co.nz",
    website: "https://www.blackcat.co.nz/",
    services: ["Nature cruises","Dolphin swimming","Private charters","Wildlife watching","Eco tours"],
    image_url: "https://www.blackcat.co.nz/wp-content/uploads/2024/10/5-1.png",
    badge: "",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 123,
    title: "Fosters Chandlery",
    description: "For over 113 years, Fosters Chandlery has been a leading provider of high-quality sailing supplies and boat accessories in New Zealand. As Auckland's go-to chandlery destination, they stock top brands like Harken, Marlow, Spinlock and Ronstan alongside traditional products like oakum and copper nails. Their expertise ensures you get the best marine products and service for a safe, fast and enjoyable time on the water.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 445 5001",
    email: "sales@fostersshipchandlery.co.nz",
    website: "https://fostersshipchandlery.co.nz/",
    services: ["Sailing hardware","Harken stockist","Marlow ropes","Spinlock gear","Ronstan blocks","Safety equipment","Traditional chandlery"],
    image_url: "https://fostersshipchandlery.co.nz/cdn/shop/files/mar_900x600.jpg?v=1706136455",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 124,
    title: "Cater Marine",
    description: "Cater Marine Opua has a tradition in fine marine outfitting with over 30 years of supplying chandlery. Situated in Opua, Bay of Islands, the first port of call for yachts arriving in New Zealand. In immediate vicinity to Opua Marina and Ashby's Boat Yard, Cater Marine is at the heart of the thriving Opua Marine Park - the perfect stop for cruising sailors exploring the beautiful Bay of Islands.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 5,
    region_name: "Far North",
    phone: "+64 9 402 7345",
    email: "info@catermarine.co.nz",
    website: "https://www.catermarine.co.nz/",
    services: ["Marine outfitting","Chandlery","Yacht supplies","Provisions","Opua marina services"],
    image_url: "https://marinelink.co.nz/images/listings/listing-124.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 125,
    title: "All Marine Whangarei",
    description: "All Marine is Whangarei's trusted marine chandlery, locally owned with over 40 years of experience getting boaties back on the water. Their friendly, boat-mad team offers practical advice and great pricing on everything from antifoul to electronics. Stocking top brands including Harken, Lowrance, Raymarine, Simrad, Hutchwilco and International Paints, they also provide safety equipment servicing and life raft maintenance.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 18,
    region_name: "Whangarei",
    phone: "+64 9 438 8353",
    email: "info@allmarine.co.nz",
    website: "https://allmarine.co.nz/",
    services: ["Chandlery","Safety equipment servicing","Antifoul paint","Marine electronics","Fishing gear","VHF radios","Life raft servicing"],
    image_url: "https://allmarine.co.nz/site/includes/plugin/thumb/phpThumb.php?src=..%2F..%2F..%2Ffile%2Fproduct%2F649%2F2026-tubester-ob.jpg&w=500&h=500&far=1&bg=ffffff&hash=71f56c2941fe5bea9ccf7e59dc8d9d77",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 126,
    title: "Absolute Marine",
    description: "Absolute Marine have been dedicated to wholesaling marine chandlery, electronics and hardware to the New Zealand marine industry for over 20 years. They offer a full range of general chandlery, boat equipment and marine accessories to suit all boaties. Their extensive catalogue covers everything from deck hardware to electrical fittings, serving trade customers across the country.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 445 5001",
    email: "info@absolutemarine.co.nz",
    website: "https://www.absolutemarine.co.nz/",
    services: ["Wholesale chandlery","Marine electronics","Deck hardware","Boat accessories","Trade supply"],
    image_url: "https://www.absolutemarine.co.nz/image/catalog/gallery/Lion.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 127,
    title: "MarineXpress",
    description: "MarineXpress supplies premium and durable boat accessories NZ-wide. They stock a large range of marine accessories, parts and chandlery for boats and trailers, both imported and NZ-made, with exclusive trade rights to top brands. Their online store makes it easy to find quality marine parts delivered to your door anywhere in New Zealand.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 444 1234",
    email: "sales@marinexpress.co.nz",
    website: "https://www.marinexpress.co.nz/",
    services: ["Boat accessories","Trailer parts","Marine chandlery","Antifouling supplies","Teak care products","Online store NZ-wide"],
    image_url: "https://d1mv2b9v99cq0i.cloudfront.net/eyJidWNrZXQiOiJ3ZWItbmluamEtaW1hZ2VzIiwia2V5IjoiY3VsZW1hcmluZVwvZ2FsbGVyeS1pbWFnZVwvaXRlbS01Ny5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjMwMDAsImhlaWdodCI6MzAwMCwiZml0IjoiaW5zaWRlIiwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfX0sInZlcnNpb24iOiJiYmUyMzU1MGY3N2QyZDJhMDEyZTM1ODMzYTYxYzdjNDI3YTZiYmVmIn0=",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 128,
    title: "Boat Bits",
    description: "Boat Bits is a proud family-owned NZ-based online marine chandlery selling premium marine products sourced from Europe. Devoted to offering products of the highest quality at competitive prices, their extensive selection includes friction rings, solar-powered lighting, boat hooks, and buoy catchers. All products are chosen for their durability and strength to endure New Zealand's distinctive maritime climate.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "",
    email: "info@boatbits.co.nz",
    website: "https://boatbits.co.nz/",
    services: ["Online chandlery","Friction rings","Boat hooks","Solar lighting","Buoy catchers","Premium European brands","NZ-wide delivery"],
    image_url: "https://boatbits.co.nz/wp-content/uploads/2021/12/Auckland-harbour-bridge.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 129,
    title: "Yacht Supplies Chandlery",
    description: "Yacht Supplies Chandlery is Nelson's go-to for quality marine hardware and cordage, located in the blue containers across from H dock at Nelson Marina. Associated with Ropetek Rigging, they're agents for Garhauer marine hardware - the best value hardware that money can buy with a 10-year guarantee. Stockists for Wichard, Selden, Spinlock, Fineline and Walder, supplying all major brands including Harken, Lewmar and Anderson.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 10,
    region_name: "Nelson",
    phone: "+64 3 548 6230",
    email: "info@yachtsupplies.co.nz",
    website: "https://www.yachtsupplies.co.nz/",
    services: ["Marine hardware","Cordage and ropes","Garhauer agent","Rigging supplies","Wichard stockist","Splicing","Nelson marina location"],
    image_url: "https://marinelink.co.nz/images/listings/listing-129.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 130,
    title: "Barton Marine NZ",
    description: "Barton Marine NZ is Wellington's leading marine retail specialist, established in 1965. Located at 80 Cable Street, they stock everything for sailing, boating, fishing and safety. With over 50 years of experience, their knowledgeable team provides personalised service and tailored advice. Independently NZ-owned and committed to supporting local sailors, fishermen and boating enthusiasts.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 16,
    region_name: "Wellington",
    phone: "+64 4 385 1490",
    email: "info@bartonmarine.co.nz",
    website: "https://bartonmarine.co.nz/",
    services: ["Sailing gear","Boating equipment","Marine safety gear","Maintenance products","Fishing supplies","Gift cards","Wellington store"],
    image_url: "https://bartonmarine.co.nz/cdn/shop/files/Barton_Marine.jpg?v=1716163684",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 131,
    title: "Mahurangi Marine",
    description: "Mahurangi Marine has been the trusted marine shop for Auckland North boaties since 1996, located in Snells Beach. As an authorised dealer for Honda and Yanmar engines, they offer outboard sales, servicing, parts, dive bottle fills and a full chandlery. From Gulf Harbour to Kaipara, their mobile boat servicing technicians cater to commercial fishing boats, launches, tinnies and trailer-craft across the greater Rodney area.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 425 5806",
    email: "info@mahumarine.co.nz",
    website: "https://www.mahumarine.co.nz/",
    services: ["Chandlery","Outboard sales & servicing","Honda & Yanmar dealer","Dive bottle fills","Boat brokerage","Marine electronics","Fish finders"],
    image_url: "https://www.mahumarine.co.nz/wp-content/uploads/2020/02/boat-shop-auckland.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 132,
    title: "Mr Boats",
    description: "Mr Boats is a Christchurch-based marine supply store with showrooms in Christchurch and Timaru, serving Canterbury boaties for decades. Part of the Boating & Outdoors buying group, they carry a wide range of boating accessories, outboards, chandlery and marine hardware. Their Bromley store on Dyers Road is open six days a week with competitive pricing and knowledgeable staff.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 3,
    region_name: "Canterbury",
    phone: "+64 3 384 2726",
    email: "sales@mrboats.co.nz",
    website: "https://mrboats.co.nz/",
    services: ["Boating accessories","Outboards","Chandlery","Marine hardware","Boat parts","Christchurch & Timaru stores"],
    image_url: "https://mrboats.co.nz/wp-content/uploads/2015/11/New-Boat-Website.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 133,
    title: "Oborn's Nautical",
    description: "Oborn's Nautical is a full-service marine hardware store and workshop in Christchurch, locally owned and trusted since 1966. They specialise in Ronstan hardware, custom boat fittings, masts, spars, rigging systems, wires, ropes and splicing. Their experienced team are all sailors who provide expert advice on marine supplies. They also offer architectural and structural wire and rod systems for non-marine applications.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 3,
    region_name: "Canterbury",
    phone: "+64 3 377 1800",
    email: "info@obornsnautical.co.nz",
    website: "https://obornsnautical.co.nz/",
    services: ["Marine hardware","Rigging systems","Masts & spars","Ropes & splicing","Ronstan specialist","Custom boat fittings","On-site workshop"],
    image_url: "https://cdn.shopify.com/s/files/1/0266/9671/2274/files/Oborns_Nautical_Online_Shop_3_fe9c07f7-5321-4169-a560-d9e77120e5a2.jpg?v=1621912652",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 134,
    title: "The Chandlery NZ",
    description: "The Chandlery is the sole New Zealand stockist of Henri-Lloyd, the iconic British sailing brand worn by the world's most accomplished sailors since 1963. Their online store offers Henri-Lloyd waterproof sailing jackets, pants, coastal and offshore gear, and marine clothing. From baselayers to shell layers, The Chandlery outfits Kiwi sailors with technical clothing built to perform in the toughest maritime conditions.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "",
    email: "info@thechandlery.co.nz",
    website: "https://thechandlery.co.nz/",
    services: ["Henri-Lloyd sailing clothing","Waterproof jackets","Offshore gear","Midlayers & baselayers","Crew kit & event merch","NZ-wide online store"],
    image_url: "https://thechandlery.co.nz/cdn/shop/files/3.png?v=1751489598",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 135,
    title: "Smart Marine",
    description: "Smart Marine has been proudly operating for over 45 years, with five specialist boating and fishing retail super stores across Auckland, Hamilton and Tauranga. Their crew of keen boaties and fishos stock over 17,000 product lines including marine chandlery, electronics, inflatable boats, water sports gear, fishing equipment and motorhome accessories. Part of NZ's largest marine buying group, they offer competitive prices and expert advice.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 262 1234",
    email: "info@smartmarine.co.nz",
    website: "https://www.smartmarine.co.nz/",
    services: ["Marine chandlery","Marine electronics","Fishing gear","Inflatable boats","Water sports","Safety equipment","5 stores nationwide"],
    image_url: "https://marinelink.co.nz/images/listings/listing-135.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 136,
    title: "Steve's Marine Supplies",
    description: "Steve's Marine Supplies is Tauranga's one-stop shop for all marine needs, offering a diverse range of quality products backed by a friendly, helpful and experienced team. Stocking top brands including MinnKota, Humminbird, Zhik, Raymarine, Harken, Ronstan, Lewmar and International Paints. Now operating as an online store with orders dispatched weekly, serving boat builders and boaties across New Zealand.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "+64 7 578 0903",
    email: "info@stevesmarine.co.nz",
    website: "https://www.stevesmarine.co.nz/",
    services: ["Marine chandlery","Marine electronics","Safety equipment","Marine paint","Harken & Ronstan stockist","Online store","Tauranga-based"],
    image_url: "https://www.stevesmarine.co.nz/images.php?oid=127",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 137,
    title: "Burnsco",
    description: "Burnsco is New Zealand's largest boating, sailing, fishing, motorhome and outdoors gear and accessories retailer. With stores in Auckland, Wellington, Christchurch, Whangarei, Opua, Hamilton, Tauranga, Nelson and Waikawa, they've been serving Kiwi boaties for generations. Their massive range covers everything from anchors and rope to electronics, safety gear, antifoul paint and fishing tackle, available online and in-store nationwide.",
    category_id: "chandlers",
    category_name: "Marine Chandlers",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 262 1234",
    email: "info@burnsco.co.nz",
    website: "https://www.burnsco.co.nz/",
    services: ["Boating supplies","Sailing gear","Fishing tackle","Marine electronics","Safety equipment","Antifoul paint","Motorhome accessories","9 stores nationwide"],
    image_url: "https://marinelink.co.nz/images/listings/listing-137.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 138,
    title: "Big Fish Bay of Islands",
    description: "A 6-hour fishing charter where hard-fighting kingfish and trophy snapper are the game. Based in the Bay of Islands, Big Fish offers both shared and private charters aboard a Surtees boat fitted with Shimano gear and Bonze lures. Target snapper, kingfish, tuna, and marlin in some of New Zealand's most productive waters.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 5,
    region_name: "Far North",
    phone: "+64 27 569 6067",
    email: "",
    website: "https://bigfishbayofislands.co.nz/",
    services: ["Deep sea fishing","Kingfish charters","Snapper trips","Private charters","Game fishing"],
    image_url: "https://marinelink.co.nz/images/listings/listing-138.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 139,
    title: "Fish 'n' Dips Charters",
    description: "Locally owned and operated fishing charters on Auckland's Hauraki Gulf. Fish 'n' Dips offers private full-day inshore and offshore trips targeting trophy snapper and kingfish on lures. Experience legendary workup feeding frenzies where dolphins, whales and birds push bait to the surface. Also runs trips to Great Barrier Island for multi-species adventures.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "",
    email: "",
    website: "https://fishndips.co.nz/",
    services: ["Inshore fishing","Offshore fishing","Workup fishing","Great Barrier Island trips","Private charters"],
    image_url: "https://fishndips.co.nz/wp-content/uploads/20221206_105819-scaled-1200x628-cropped.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 140,
    title: "Pelagic Charters",
    description: "New Zealand's premium long-range fishing charter company. Pelagic Charters travels to the legendary Three Kings Islands, North Cape, and the Ranfurly Banks targeting striped marlin, blue marlin, swordfish, yellowtail kingfish, hapuka, and bass. Multi-day liveaboard trips aboard MV Pelagic, a 9m White Pointer. Departing from Mangonui, Auckland, and Tauranga depending on season.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 5,
    region_name: "Far North",
    phone: "",
    email: "",
    website: "https://pelagiccharters.co.nz/",
    services: ["Three Kings Islands charters","Game fishing","Swordfish trips","Kingfish charters","Multi-day liveaboard"],
    image_url: "https://pelagiccharters.co.nz/wp-content/uploads/2025/04/Monster-Kingfish-Charter-NZ-1024x577.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 141,
    title: "Spot-X Fishing Charters",
    description: "Bay of Islands daily fishing trips aboard Wairere and Screaming Reels. Spot-X offers half-day snapper trips, full-day kingfish adventures, and deep sea trips for hapuka and broadbill. Also runs unique historical tours in collaboration with Russell Museum. Shared seats available or book the whole boat. Cook your catch at local restaurants with their fresh fish for dinner program.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 5,
    region_name: "Far North",
    phone: "",
    email: "",
    website: "https://www.fishspotx.co.nz/",
    services: ["Snapper charters","Kingfish charters","Deep sea fishing","Historical tours","Shared or private trips"],
    image_url: "https://marinelink.co.nz/images/listings/listing-141.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 142,
    title: "Epic Adventures Fishing Charters",
    description: "The Kingfish Guys! Epic Adventures operates out of Whitianga on the Coromandel Peninsula, targeting XXL yellowtail kingfish. With 15+ years of experience and 6,500+ kingfish released, their expert skippers deliver lifetime memories. State-of-the-art vessels equipped with the latest technology and top-quality gear. Sustainable fishing practised with a Tiaki Promise commitment.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 4,
    region_name: "Coromandel",
    phone: "",
    email: "",
    website: "https://www.epicadventures.co.nz/",
    services: ["Kingfish charters","Full day charters","Sustainable fishing","Whitianga departures","Fishing vouchers"],
    image_url: "https://images.squarespace-cdn.com/content/v1/66b9d8982b9c8d5bc55518f9/1723455646439-53LYM37LPFGH4YUW5OI9/kingfish+1+-+half+backgrgound.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 143,
    title: "Fish Tutukaka",
    description: "Private boat charter for customised ocean adventures from Tutukaka Marina. Fish Tutukaka offers inshore and big game fishing trips, plus snorkelling, SUPing and sightseeing at the Poor Knights Islands. A local family business passionate about sharing their piece of paradise. Skippered by Captain Luke with extensive local knowledge of the Northland coast.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 18,
    region_name: "Whangarei",
    phone: "",
    email: "",
    website: "https://www.fishtutukaka.co.nz/",
    services: ["Inshore fishing","Big game fishing","Snorkelling","Stand-up paddleboarding","Scenic cruises","Poor Knights trips"],
    image_url: "https://static.wixstatic.com/media/90a441_7994c16e384242a5962f2fb52b9baa38~mv2.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 144,
    title: "Saltshaker Charters",
    description: "Deep sea fishing charters and game fishing in the Bay of Islands. Saltshaker offers extreme game fishing experiences targeting marlin, tuna, and other pelagics in Northland waters. A purpose-built charter vessel fully equipped for big game fishing adventures.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 5,
    region_name: "Far North",
    phone: "",
    email: "",
    website: "https://www.deepseafishing.co.nz/",
    services: ["Deep sea fishing","Game fishing","Marlin fishing","Tuna fishing","Bay of Islands departures"],
    image_url: "https://marinelink.co.nz/images/listings/listing-144.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 145,
    title: "Grand Cru Charters Tutukaka",
    description: "Premier deep-sea fishing charters departing from Tutukaka. Grand Cru Charters offers half-day, full-day, and overnight trips targeting a wide range of species. Fishing the rich waters around the Poor Knights Islands and beyond, with experienced skippers and quality gear provided.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 18,
    region_name: "Whangarei",
    phone: "",
    email: "",
    website: "https://www.grandcrucharters.nz/",
    services: ["Half-day fishing","Full-day charters","Overnight trips","Deep sea fishing","Poor Knights fishing"],
    image_url: "https://www.grandcrucharters.nz/wp-content/uploads/2024/07/how-long-do-fishing-charters-last-0.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 146,
    title: "Tauranga Marine Charters (MV Manutere)",
    description: "Tauranga's longest-running fishing charter operation, with MV Manutere taking anglers out for over 40 years. A purpose-built charter fishing vessel with plenty of walk-around space, perfect for individuals, families, or groups. Offering public trips, private charters, and specialised reef and hapuka fishing - targeting snapper, tarakihi, kingfish, and deep-water species year-round.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "",
    email: "",
    website: "https://www.taurangamarinecharters.co.nz/",
    services: ["Public fishing trips","Private charters","Reef fishing","Hapuka fishing","Kingfish jigging","Extended trips"],
    image_url: "https://marinelink.co.nz/images/listings/listing-146.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 147,
    title: "Hauraki Express Fishing Charters",
    description: "Family-owned fishing charter and water taxi operating on the Hauraki Gulf from Kawau Bay. Hauraki Express offers fishing trips and custom charters exploring the wonders of the gulf. Also provides water taxi services and bunkering fuel supply to vessels in the area.",
    category_id: "fishing",
    category_name: "Fishing Charters",
    region_id: 1,
    region_name: "Auckland",
    phone: "0800 546 443",
    email: "",
    website: "https://haurakiexpress.co.nz/",
    services: ["Fishing trips","Water taxi","Custom charters","Hauraki Gulf tours"],
    image_url: "https://haurakiexpress.co.nz/app/uploads/2016/12/shutterstock-26904490-1-1.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 148,
    title: "Hibiscus JetSki Hire & Tours",
    description: "Award-winning jet ski hire and tours from the Hibiscus Coast, rated top 10% of things to do worldwide and #1 boat rental operator in New Zealand. Self-guided jet ski adventures exploring the Hauraki Gulf's island-dotted horizon. Beginner friendly with fuel, safety equipment, and real-time GPS tracking included. DOC-approved pest-free operator.",
    category_id: "rentals",
    category_name: "Boat Rentals",
    region_id: 1,
    region_name: "Auckland",
    phone: "",
    email: "",
    website: "https://hibiscusjetskihire.co.nz/",
    services: ["Jet ski hire","Guided eco-tours","Self-guided adventures","6 Islands Safari","Tiritiri Matangi trips","Corporate groups"],
    image_url: "https://hibiscusjetskihire.co.nz/wp-content/uploads/2026/05/Hibiscus-Jetski-Hire-38-Father-and-daughter-quality-time-full-action-fun-ride-together.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 149,
    title: "Auckland Jet Ski Hire",
    description: "Jet ski rentals for self-exploration of Auckland waters from Maraetai. With Waiheke Island just a 15-minute jet ski sprint away, explore the beautiful Hauraki Gulf Islands at your own pace. Adrenaline-fuelled adventures on modern jet skis with full safety briefing included.",
    category_id: "rentals",
    category_name: "Boat Rentals",
    region_id: 1,
    region_name: "Auckland",
    phone: "",
    email: "",
    website: "https://www.aucklandjetskihire.co.nz/",
    services: ["Jet ski rental","Self-exploration","Waiheke Island trips","Hauraki Gulf Islands","Adrenaline experiences"],
    image_url: "https://www.aucklandjetskihire.co.nz/wp-content/uploads/2024/02/20210319_134923-1-scaled-e1707344619419.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 150,
    title: "Takapuna Jet Ski Hire",
    description: "Jet ski hire at Takapuna Beach, Auckland. Hire a jet ski for an hour or take one away for the week. Takapuna Jet Ski Hire can take care of all your jet ski rental needs, with modern Yamaha watercraft available for hire by the hour or day.",
    category_id: "rentals",
    category_name: "Boat Rentals",
    region_id: 1,
    region_name: "Auckland",
    phone: "",
    email: "",
    website: "https://www.takapunajetskihire.com/",
    services: ["Jet ski hire","Hourly rental","Weekly hire","Yamaha watercraft","Takapuna Beach departures"],
    image_url: "https://static.wixstatic.com/media/019d8e_2a858c1e73b44fefaba997086c85249a~mv2.jpg/v1/fill/w_979,h_470,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Tia1.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 151,
    title: "Lakeland Wanaka",
    description: "Jet boat, jet ski, kayak, and boat hire on Lake Wanaka. Operating from the waterfront 9am-6pm during summer, with reduced winter hours. Lakeland Wanaka offers a range of watercraft for exploring the stunning alpine lake. Weather-dependent operations in one of New Zealand's most beautiful settings.",
    category_id: "rentals",
    category_name: "Boat Rentals",
    region_id: 13,
    region_name: "Southland",
    phone: "",
    email: "",
    website: "https://www.lakelandwanaka.com/",
    services: ["Jet boat hire","Jet ski rental","Kayak hire","Boat hire","Lake Wanaka departures"],
    image_url: "https://cdn.prod.website-files.com/639d8f0f8e7435568b74fb31/639ed618e9b474d3272c44b3_Selfie%20Image.webp",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 152,
    title: "Getmyboat Auckland",
    description: "The world's #1 boat rental app, listing a huge range of boat and yacht rentals in Auckland. From luxury yachts to self-drive tinnies, kayaks to jet skis, Getmyboat connects you with local owners. Rated 4.9 stars by 500,000+ renters. Book with confidence and explore Auckland's Hauraki Gulf.",
    category_id: "rentals",
    category_name: "Boat Rentals",
    region_id: 1,
    region_name: "Auckland",
    phone: "",
    email: "",
    website: "https://www.getmyboat.com/boat-rental/Auckland--Auckland--New-Zealand/",
    services: ["Boat rentals","Yacht charters","Kayak rentals","Jet ski rentals","Self-drive boats"],
    image_url: "https://img.getmyboat.com/images/591942bf3d880/boat-rentals-auckland-auckland-processed.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 153,
    title: "Seaview Marina",
    description: "Wellington's newest and fastest developing marina, situated at the sheltered north-east end of Wellington Harbour. Seaview Marina offers 314 berths for boats up to 20m, with a world-class haul-out facility praised by international vessel owners. Diesel fuel available, 24/7 security, and a great boating community. The best all-round marina in the Wellington region.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 16,
    region_name: "Wellington",
    phone: "+64 4 570 0500",
    email: "info@seaviewmarina.co.nz",
    website: "https://www.seaviewmarina.co.nz/",
    services: ["Berth rentals","Hardstand haul-out","Diesel fuel dock","24/7 security","Marine servicing"],
    image_url: "https://zdn.nz/site/seaviewmarina/images/basic_theme/Slider%20image2.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 154,
    title: "Silo Marina",
    description: "The premier home for superyachts in the South Pacific. Silo Marina offers berths up to 140 metres in Auckland's newest waterfront destination, Wynyard Quarter. World-class facilities for large vessels, with easy access to Auckland's vibrant dining and entertainment precinct. Managed by Auckland Council Marinas.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 379 2000",
    email: "info@silomarina.co.nz",
    website: "https://www.aucklandmarinas.com/",
    services: ["Superyacht berths","Long-term berths","Casual berths","Waterfront location","Security 24/7"],
    image_url: "https://marinelink.co.nz/images/listings/silo-marina-img.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 155,
    title: "Auckland Central Marina",
    description: "Berths up to 50 metres in the heart of Auckland's vibrant waterfront, next to Viaduct Harbour and close to Wynyard Quarter. Perfect for enjoying top dining, events, and world-class entertainment. Managed by Auckland Council Marinas, offering premium facilities and easy access to the Hauraki Gulf.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 379 2000",
    email: "info@aucklandmarinas.com",
    website: "https://www.aucklandmarinas.com/",
    services: ["Berth rentals","City waterfront location","Casual berths","Long-term berths","Viaduct Harbour access"],
    image_url: "https://marinelink.co.nz/images/listings/listing-155.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 156,
    title: "Bayswater Marina",
    description: "415 full-length finger berths on Auckland's North Shore, all equipped with water and 240 volt power with earth leakage protection. Bayswater Marina provides a refuelling facility, full security, and a range of marine services. A vibrant marina community with restaurants, charter boat operators, and marine businesses on site.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 445 7114",
    email: "info@bayswatermarina.co.nz",
    website: "https://www.bayswatermarina.co.nz/",
    services: ["Finger berths","Fuel dock","Marine services","Restaurants","Charter boats","Security"],
    image_url: "https://cdn.prod.website-files.com/694eea0dcd0675d5302504f6/69531f80a6274d77de26bca2_Bayswater-Marina-31-Oct-2025-31-p-1600.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 157,
    title: "Tauranga Bridge Marina",
    description: "500 berths for vessels 10-37m just 5 minutes from famous Mount Maunganui. Tauranga Bridge Marina offers all the facilities needed for a stress-free stay, with limited multihull berths available. Easy access to beaches, restaurants, and the beautiful Bay of Plenty cruising grounds. A popular stopover for cruisers heading north or south.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "+64 7 575 1171",
    email: "info@bridgemarina.co.nz",
    website: "https://www.bridgemarina.co.nz/",
    services: ["Berths 10-37m","Multihull berths","Fuel dock","Hardstand","Pump-out","Marine services"],
    image_url: "https://www.marina.co.nz/edit/cache/images/pick1--w_750-h_750-e_jpg-c_1-cp_center-cs_3394.webp",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 158,
    title: "Marsden Cove Marina",
    description: "A modern marina at the entrance to Whangarei Harbour, offering 230 berths for vessels up to 25m. Marsden Cove is a gated marina village with fuel dock, hardstand, travel lift, and a range of marine services. The gateway to Northland's superb cruising grounds including the Bay of Islands and Poor Knights Islands. Restaurants and accommodation on site.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 18,
    region_name: "Whangarei",
    phone: "+64 9 431 3000",
    email: "info@marsdencove.co.nz",
    website: "https://www.marsdencove.co.nz/",
    services: ["Berths to 25m","Fuel dock","Hardstand","Travel lift","Gated security","Marine village"],
    image_url: "https://images.squarespace-cdn.com/content/v1/5320c0c6e4b0b54f8c30bca2/9530f4cd-3e67-45eb-b7df-f7d9cb3c342a/MCL_Feb-2025-70.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 159,
    title: "Tutukaka Marina",
    description: "A full-service marina halfway between Auckland and the Bay of Islands, and the gateway to the Poor Knights Islands Marine Reserve. Tutukaka Marina offers berths, hardstand, fuel, and marine services. A stunning location on the Tutukaka Coast, just 25 minutes from Whangarei. Popular with divers, fishers, and cruisers exploring Northland.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 18,
    region_name: "Whangarei",
    phone: "+64 9 434 3000",
    email: "",
    website: "https://www.tutukakamarina.co.nz/",
    services: ["Berth rentals","Hardstand","Fuel dock","Marine services","Gateway to Poor Knights"],
    image_url: "https://marinelink.co.nz/images/listings/tutukaka-marina-aerial.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 160,
    title: "Opua Marina",
    description: "The Bay of Islands' premier marina, located at Opua - the first port of entry for many international yachts arriving in New Zealand. Opua Marina offers 240 berths, haul-out facilities, and a full range of marine services. A vibrant cruising community and the perfect base for exploring the Bay of Islands and beyond.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 5,
    region_name: "Far North",
    phone: "+64 9 402 7080",
    email: "info@opuamarina.co.nz",
    website: "https://www.opuamarina.co.nz/",
    services: ["Berth rentals","Port of entry","Haul-out","Marine services","Cruiser community","Bay of Islands access"],
    image_url: "https://marinelink.co.nz/images/listings/listing-160.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 161,
    title: "Gulf Harbour Marina",
    description: "Located on the Whangaparaoa Peninsula, Gulf Harbour Marina offers berths for vessels up to 18m. The marina features a travel lift, hardstand, and a range of marine businesses including boat builders, marine engineers, and marine surveyors. A convenient base for exploring the Hauraki Gulf, with nearby golf course and residential community.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 424 5056",
    email: "info@gulfharbourmarina.co.nz",
    website: "https://www.gulfharbourmarina.co.nz/",
    services: ["Berth rentals","Travel lift","Hardstand","Marine businesses","Hauraki Gulf access"],
    image_url: "https://marinelink.co.nz/images/listings/listing-161.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 162,
    title: "Pine Harbour Marina",
    description: "A full-service marina on Auckland's eastern shores at Beachlands. Pine Harbour Marina offers berth rentals, hardstand, travel lift, and a comprehensive range of marine services including boat builders, engineers, and marine electronics. Also features a ferry service to Auckland CBD and a popular cafe. The closest marina to the Coromandel Peninsula from Auckland.",
    category_id: "marinas",
    category_name: "Marinas & Berths",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 536 6000",
    email: "info@pineharbour.co.nz",
    website: "https://www.pineharbour.co.nz/",
    services: ["Berth rentals","Hardstand","Travel lift","Marine services","Ferry to CBD","Cafe"],
    image_url: "https://cdn.prod.website-files.com/68c9d92e6d19ccf7946d7237/6941d5aeed27bcf79032eb03_Pine-Harbour-6.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 163,
    title: "The Boat Builders",
    description: "Passionate Auckland boaties have trusted The Boat Builders since 1980. Located at the hardstand end of Half Moon Bay Marina, they offer a one-stop service for all marine requirements. From full deck replacements to new rudders, keel repairs, and insurance work - their skilled craftsmen handle glass, timber, and composite construction to the highest standards.",
    category_id: "builders",
    category_name: "Boat Builders & Repair",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 570 5344",
    email: "info@theboatbuilders.co.nz",
    website: "https://theboatbuilders.co.nz/",
    services: ["Repairs & maintenance","Fibreglass & composite","Classic restorations","Cabinetry","Teak decks","Insurance repairs"],
    image_url: "https://hmbmarina.co.nz/wp-content/uploads/2025/11/TheBoatBuilders-Website-2880w.webp",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 164,
    title: "Cove Boatworks",
    description: "Experienced shipwrights and boat builders at Marsden Cove hardstand and marina. Cove Boatworks handles everything from modern vacuum infusion to traditional wooden boat building, plumbing to mechanical repairs. Covered shed space for vessels to 65' long and 25' wide, with hardstand capacity to 80 tonnes. Specialist applicator for Propspeed.",
    category_id: "builders",
    category_name: "Boat Builders & Repair",
    region_id: 18,
    region_name: "Whangarei",
    phone: "",
    email: "info@coveboatworks.com",
    website: "https://coveboatworks.com",
    services: ["Boat building","Refits & alterations","Osmosis & rot repair","Teak decking","Propspeed application","Project management"],
    image_url: "https://coveboatworks.com/images/CoveBoatworks_Social.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 165,
    title: "Brin Wilson Boats",
    description: "Boat building since 1952. Brin Wilson Boat Builders at Gulf Harbour Marina, Auckland, are your local experts for boat repair, refits, Flexiteek decking, and osmosis repair. With over 200 years of collective expertise and 70+ years in business, their fully enclosed 1200 sqm workshop allows year-round work regardless of weather.",
    category_id: "builders",
    category_name: "Boat Builders & Repair",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 424 0224",
    email: "info@brinwilsonboats.co.nz",
    website: "https://www.brinwilsonboats.co.nz/",
    services: ["Refits & restorations","Flexiteek 3G decks","Osmosis repair","Maintenance & antifoul","Wood & fibreglass","Composite work"],
    image_url: "https://images.squarespace-cdn.com/content/v1/68b4cee211908273789867e1/4e23647d-189d-4fed-9431-c88d3d76aad3/twoboats.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 166,
    title: "Condon Marine Services",
    description: "Trusted boat builder and repairer servicing vessels of all sizes, from trailer boats and jet skis to superyachts and commercial vessels. Founded by Liam Condon in 2018, CMS specialises in boat building, fibreglass repairs, and insurance-approved repair work. Based in Auckland with a reputation for quality workmanship across all vessel types.",
    category_id: "builders",
    category_name: "Boat Builders & Repair",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 570 5344",
    email: "info@condonmarineservices.co.nz",
    website: "https://www.condonmarineservices.co.nz/",
    services: ["Boat building","Fibreglass repairs","Insurance repairs","Superyacht refits","Commercial vessels","Jet ski repairs"],
    image_url: "https://www.condonmarineservices.co.nz/wp-content/uploads/2021/07/cropped-condon_marine_services_auckland_boat_repairs_maintenance_0.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 167,
    title: "Pine Harbour Boat Painters",
    description: "Professional boat building, painting, and repair services at Pine Harbour Marina. Services include structural repairs and modifications, refits and restorations, interior and exterior fit-outs, and fibreglass repairs. Expert craftsmanship and modern techniques bring classic boats back to life and keep modern vessels in top condition.",
    category_id: "builders",
    category_name: "Boat Builders & Repair",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 536 6000",
    email: "info@phbp.co.nz",
    website: "https://www.phbp.co.nz/",
    services: ["Boat building","Structural repairs","Refits & restorations","Interior & exterior fit-outs","Fibreglass repairs","Boat painting"],
    image_url: "https://images.squarespace-cdn.com/content/v1/64a22cc23da7210c8985a46e/b2fc3fdb-478a-45d4-a3c9-45f2c927f4eb/1stage+2-21.jpeg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 168,
    title: "Boat Repairs Auckland",
    description: "Boat, jet ski, hull, and fibreglass repairs in Auckland. Boat Repairs are proud to offer boat builders on the North Shore and comprehensive boat maintenance services. From minor gelcoat fixes to major structural repairs, their experienced team keeps your vessel in top condition.",
    category_id: "builders",
    category_name: "Boat Builders & Repair",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 410 1234",
    email: "info@boatrepairs.co.nz",
    website: "https://www.boatrepairs.co.nz/",
    services: ["Fibreglass repairs","Hull repairs","Jet ski repairs","Gelcoat","Boat maintenance","North Shore Auckland"],
    image_url: "https://www.boatrepairs.co.nz/files/cache/9b4275d01a45cc9e14e0f27148a886d7.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 169,
    title: "Superior Group (South Auckland Boat Repairs)",
    description: "South Auckland Boat Repairs has been repairing, maintaining, and altering fibreglass boats since 1987. Part of the Superior Group, they also manufacture Shuttle Trailers and provide fibreglass repair services. Decades of experience with all types of fibreglass vessels, from small runabouts to larger launches.",
    category_id: "builders",
    category_name: "Boat Builders & Repair",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 268 1200",
    email: "info@superiorgroup.co.nz",
    website: "https://www.superiorgroup.co.nz/",
    services: ["Fibreglass repairs","Boat maintenance","Boat alterations","Shuttle Trailers","South Auckland"],
    image_url: "https://marinelink.co.nz/images/listings/listing-169.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 170,
    title: "Onshore Marine Engineering",
    description: "Auckland-based mobile marine engineering company covering all boat mechanical needs. Led by Jake and his team of qualified technicians, Onshore Marine is known for finding and fixing problems rather than throwing parts at them. Highly rated for outdrive servicing, Volvo diesel repairs, and general marine mechanical work across the Auckland region.",
    category_id: "engineering",
    category_name: "Marine Engineering",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 21 0227 3232",
    email: "info@onshoremarine.co.nz",
    website: "https://www.onshoremarine.co.nz/",
    services: ["Mobile marine engineering","Diesel engine servicing","Outdrive repairs","Volvo Penta service","Diagnostics"],
    image_url: "https://images.squarespace-cdn.com/content/v1/6029a8e99f10401f2e5da426/48c6b16d-1eab-4b06-94db-43ec3d82879f/Untitled+%28500+x+150+px%29.png?format=1500w",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 171,
    title: "Marine Diesel Solutions",
    description: "Auckland's trusted marine engineering specialists based at Pine Harbour Marina. Led by Allister Spick with over 20 years of experience across commercial vessels, leisure craft, superyachts, and premium charter boats. Specialises in marine diesel engine maintenance, repairs, repowers, propulsion systems, hydraulic systems, and insurance-approved repairs for all major brands.",
    category_id: "engineering",
    category_name: "Marine Engineering",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 536 6000",
    email: "info@marinedieselsolutions.co.nz",
    website: "https://www.marinedieselsolutions.co.nz/",
    services: ["Engine servicing","Engine repowers","Propulsion systems","Hydraulic systems","Insurance repairs","Marine parts"],
    image_url: "https://images.squarespace-cdn.com/content/67db400649b935648edcb585/7ba3dc04-77e7-49e6-9b27-4a5f135b39ea/MDS-social.jpg?content-type=image%2Fjpeg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 172,
    title: "Eastern Marine",
    description: "East Auckland's repower centre at Pine Harbour Marina. A Certified Mercury Service Centre specialising in repowers, sales, and service. Also authorised dealers for FPT, Hyundai Infracore, Zenith, and Paguro. Eastern Marine services and repairs all makes and models of marine propulsion equipment for all vessel types, with a full workshop facility and experienced team.",
    category_id: "engineering",
    category_name: "Marine Engineering",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 536 6000",
    email: "info@easternmarine.co.nz",
    website: "https://easternmarine.co.nz/",
    services: ["Mercury outboards","Sterndrives & inboards","Mercury Diesel","Large diesel & generators","Repowers","All-brand servicing"],
    image_url: "https://easternmarine.co.nz/wp-content/uploads/2025/08/Mercury_Diesel.webp",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 173,
    title: "Shaw Diesels",
    description: "Marine engineers who know boats inside and out. Shaw Diesels has been keeping commercial vessels and pleasurecraft running for over 30 years. Authorised dealer for Isuzu Marine, Lister Petter, and Gardner, plus Vortum and Zenith marine generators, and Dong-I gearboxes and steering. Services range from 5hp to 5,000hp, covering all major brands. 24/7 callout available across NZ and the Pacific.",
    category_id: "engineering",
    category_name: "Marine Engineering",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 414 7360",
    email: "info@shawdiesels.co.nz",
    website: "https://shawdiesels.co.nz/",
    services: ["Engine servicing","Repairs & diagnostics","Engine rebuilds","Engine repowers","Marine generators","24/7 callout"],
    image_url: "https://shawdiesels.co.nz/wp-content/uploads/2026/05/Shaw-HOME-repairs.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 174,
    title: "General Marine",
    description: "Comprehensive marine engineering services covering all marine systems from main engines and generators to pumps, watermakers, treatment plants, dive compressors, davits, and cranes. General Marine's experienced diesel mechanics handle all aspects of vessel maintenance and repair for commercial and leisure vessels.",
    category_id: "engineering",
    category_name: "Marine Engineering",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 414 7000",
    email: "info@generalmarine.co.nz",
    website: "https://www.generalmarine.co.nz/",
    services: ["Marine diesel engines","Generators","Pumps & plumbing","Watermakers","Dive compressors","Davits & cranes"],
    image_url: "https://marinelink.co.nz/images/listings/listing-174.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 175,
    title: "Electronic Navigation Ltd (ENL)",
    description: "New Zealand's premier marine electronics company since 1945. ENL equips New Zealanders - and now the world - with the best marine electronics. Specialists in solutions for seabed surveying, mapping, defence, superyachts, commercial fishing, and workboats. Authorised dealer for Furuno and developer of the Wassp multibeam sonar system.",
    category_id: "electronics",
    category_name: "Marine Electronics",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 479 3000",
    email: "info@enl.co.nz",
    website: "https://www.enl.co.nz/",
    services: ["Marine electronics","GPS & chartplotters","Fish finders & sonar","Radar","Commercial marine systems","Defence solutions"],
    image_url: "https://www.enl.co.nz/cdn/shop/files/S3_3d_bathy_FB_1200x1200.png?v=1613539999",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 176,
    title: "Bay Marine Electronics",
    description: "For 30 years, Bay Marine Electronics has sold and installed fish finders, chartplotters, radar, VHF, and entertainment equipment into pleasure and commercial craft across New Zealand. One of the biggest independent marine electronics resellers in NZ, stocking Furuno, Garmin, Simrad, Icom, Airmar, Minn Kota, Starlink, Zipwake, and Fusion. No parallel imports - all products come with factory-backed warranty.",
    category_id: "electronics",
    category_name: "Marine Electronics",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "+64 7 575 1171",
    email: "info@baymarineelectronics.co.nz",
    website: "https://www.baymarineelectronics.co.nz/",
    services: ["Fish finders","Chartplotters","Radar","VHF radios","Trolling motors","Entertainment systems"],
    image_url: "https://pictures.rs-cdn.com/CF-a185c574-161e-4e65-9c39-e53c0c56511d/width=1200,height=1367,fit=scale-down,sharpen=0.00/4f095e26e5091de6ff83b27c7ab9bb58.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 177,
    title: "East Coast Marine Electronics",
    description: "Marine electronics sales, installation, and support across the Bay of Plenty, Coromandel Peninsula, and Rotorua. Specialists in fishfinder setup, transducer selection, and sounder tuning. Mobile service - can come to your boat or marina. Clean installs with no shortcuts, systems set up for real fishing conditions. 5-star rated with 40+ Google reviews.",
    category_id: "electronics",
    category_name: "Marine Electronics",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "+64 27 200 0000",
    email: "info@ecme.co.nz",
    website: "https://ecme.co.nz/",
    services: ["Marine electronics sales","Professional installation","Mobile service","Fishfinder specialists","Garmin & Simrad","Ongoing support"],
    image_url: "https://ecme.co.nz/cdn/shop/files/1653-2.jpg?v=1773276305&width={width}",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 178,
    title: "Marine Deals",
    description: "New Zealand's leading online marine electronics retailer. Marine Deals offers the best prices on GPS chartplotters, fish finders, and marine electronics from top brands including Lowrance, Garmin, Raymarine, B&G, and Simrad. Large stock range with fast delivery nationwide and a physical store in Auckland.",
    category_id: "electronics",
    category_name: "Marine Electronics",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 444 2345",
    email: "info@marinedeals.co.nz",
    website: "https://www.marine-deals.co.nz/",
    services: ["GPS chartplotters","Fish finders","Marine electronics","Transducers","VHF radios","Online retail"],
    image_url: "https://marine-deals.freetls.fastly.net/media/special/banners/m/i/midweek_010726-858x400.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 179,
    title: "Dive Centre Auckland",
    description: "New Zealand's longest-serving dive family, running Dive Centre Ltd since 1972. Auckland's North Shore facility dedicated to showing you the best gear and advice in New Zealand. PADI award-winning instructors, NZ's largest scuba equipment service company with two fulltime technicians, IANZ-approved cylinder testing, Bauer compressors for high-quality air and Nitrox. Approved Suunto service centre.",
    category_id: "diving",
    category_name: "Diving & Water Sports",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 444 7698",
    email: "info@scuba.co.nz",
    website: "https://scuba.co.nz/",
    services: ["Scuba courses","Dive gear sales","Equipment servicing","Cylinder testing","Air & Nitrox fills","Suunto service"],
    image_url: "https://scuba.co.nz/content/images/slideshow/eagle-ray-hammerheads.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 180,
    title: "Auckland Scuba Dive & Snorkelling",
    description: "A PADI 5 Star Instructor Development and TecRec Center offering the absolute best in diving and certification courses. As one of New Zealand's leading dive centres, Auckland Scuba specialises in Scuba Instructor Training with full and part-time programs. Offers NZQA-approved courses including the NZ Diploma in Professional Scuba Instruction. Large retail area with international brands and online store.",
    category_id: "diving",
    category_name: "Diving & Water Sports",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 415 0234",
    email: "info@aucklandscubadive.co.nz",
    website: "https://www.aucklandscubadive.co.nz/",
    services: ["PADI courses","Instructor training","Technical dive training","Dive gear sales","Air fills","Cylinder testing"],
    image_url: "https://www.aucklandscubadive.co.nz/blog/wp-content/uploads/2026/02/200lx.jpeg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 181,
    title: "Paihia Dive & Snorkel",
    description: "Bay of Islands' premier dive operator offering SSI diving courses and trips. Paihia Dive provides diving in the most beautiful locations in the Bay of Islands, including the famous Rainbow Warrior wreck. Experience the underwater world of Northland with experienced local guides. Full gear hire available and trips suitable for all levels.",
    category_id: "diving",
    category_name: "Diving & Water Sports",
    region_id: 5,
    region_name: "Far North",
    phone: "0800 107 551",
    email: "info@divenz.com",
    website: "https://divenz.com/",
    services: ["Dive trips","SSI courses","Snorkelling trips","Wreck diving","Equipment hire","Bay of Islands diving"],
    image_url: "https://marinelink.co.nz/images/listings/listing-181.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 182,
    title: "Dive! Tutukaka",
    description: "The gateway to the world-renowned Poor Knights Islands Marine Reserve. Dive! Tutukaka operates from Tutukaka Harbour, 25 minutes from Whangarei, offering daily dive trips, PADI courses, and full gear hire. The Poor Knights are noted for prolific game fishing and some of the most amazing diving in New Zealand - both aqualung and snorkelling. A full-service marina with dive charter vessels.",
    category_id: "diving",
    category_name: "Diving & Water Sports",
    region_id: 18,
    region_name: "Whangarei",
    phone: "+64 9 434 3867",
    email: "info@diving.co.nz",
    website: "https://diving.co.nz/",
    services: ["Dive trips to Poor Knights","PADI courses","Snorkelling","Equipment hire","Dive charters","Marine Reserve diving"],
    image_url: "https://diving.co.nz/media/images/_teaser/10.09.12-Bright-Arrow-19.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 183,
    title: "New Zealand Diving Training and Tours",
    description: "Diving charters dedicated to training recreational and technical scuba divers alike. From those just starting their adventure into diving to those wanting to continue onto the next level and discover what diving is truly about. Services can be tailored to requirements, catering for both recreational and technical groups. Wreck diving tours in the Bay of Islands included.",
    category_id: "diving",
    category_name: "Diving & Water Sports",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 27 283 7038",
    email: "info@newzealanddiving.co.nz",
    website: "https://www.newzealand.com/us/plan/business/new-zealand-diving/",
    services: ["Recreational diving","Technical diving","Dive training","Wreck tours","Bay of Islands trips","Custom charters"],
    image_url: "https://marinelink.co.nz/images/listings/listing-183.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 184,
    title: "Goat Island Dive & Snorkel",
    description: "Dive and snorkel at New Zealand's first marine reserve - Goat Island, Leigh. Just an hour north of Auckland, this protected area offers abundant marine life including snapper, blue maomao, and crayfish in their natural habitat. Glass-bottom boat tours, snorkel hire, and dive trips available. Perfect for families and first-time snorkellers.",
    category_id: "diving",
    category_name: "Diving & Water Sports",
    region_id: 5,
    region_name: "Far North",
    phone: "+64 9 422 6773",
    email: "info@goatislanddive.co.nz",
    website: "https://goatislanddive.co.nz/",
    services: ["Snorkelling","Dive trips","Glass-bottom boat tours","Equipment hire","Marine reserve visits","Family-friendly"],
    image_url: "https://marinelink.co.nz/images/listings/listing-184.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 185,
    title: "Dave Giddens Sailmakers",
    description: "Auckland's trusted sailmakers and marine canvas specialists since 1980. Dave Giddens Sailmakers specialises in fabricating and refurbishing custom-made marine covers and upholstery in any marine grade outdoor fabric including PVC and canvas. Services include sail repairs and alterations, marine trimming, shade sails, waterproof PVC sails, and architectural awnings. Located in Kingsland.",
    category_id: "sailmakers",
    category_name: "Sailmakers & Canvas",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 815 7027",
    email: "info@sailmakers.co.nz",
    website: "https://sailmakers.co.nz/",
    services: ["Sail repairs","Marine covers & canopies","Biminis & dodgers","Upholstery","Shade sails","Awnings"],
    image_url: "https://sailmakers.co.nz/wp-content/uploads/2015/09/2015-11-08-13_03_58-The-Dave-Giddens-Story_Boating-New-Zealand-_Dec14.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 186,
    title: "Evolution Sails New Zealand",
    description: "Owned by Rodney Keenan, Evolution Sails NZ is part of an international world-class sail manufacturing, repair, and service organization. ENZ manufactures and services sails for superyachts, grand prix racing yachts, large cruising yachts, and domestic racing and cruising yachts. Purpose-built sailmaking facility in Auckland, City of Sails. Team includes America's Cup, Volvo Round the World, and Olympic Games veterans.",
    category_id: "sailmakers",
    category_name: "Sailmakers & Canvas",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 815 7028",
    email: "info@evolutionsails.com",
    website: "https://www.evolutionsails.com/sail-lofts/new-zealand/",
    services: ["New sails","Sail repair","Superyacht sails","Racing sails","Cruising sails","Sail design"],
    image_url: "https://www.evolutionsails.com/wp-content/uploads/Spinnaker-2.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 187,
    title: "Willis Sails",
    description: "World class sailmakers in the Bay of Islands since 1983. Willis Sails builds fast sails that last for cruisers and racers worldwide. Fully qualified sailmakers using the latest sailmaking technology to design and build all sails in-house. Reputation for building long-lasting sails that perform flawlessly - trusted by circumnavigators and racers alike.",
    category_id: "sailmakers",
    category_name: "Sailmakers & Canvas",
    region_id: 5,
    region_name: "Far North",
    phone: "+64 9 403 8023",
    email: "info@willissails.co.nz",
    website: "https://www.willissails.co.nz/",
    services: ["New sails","Sail repair","Cruising sails","Racing sails","Sail design","Bay of Islands"],
    image_url: "https://www.willissails.co.nz/img/boats-one.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 188,
    title: "UK Sailmakers Whangarei (Northland Canvas)",
    description: "Owned by Phil Houghton, a sailmaker for over 33 years with experience including NZ's first America's Cup Challenger, Whitbread Maxi Steinlager, and Shore Sailmaker for the winning Yamaha Whitbread 60 team. UK Sailmakers Whangarei provides advanced sail designs, premium fabric selection, and quality hardware. Full range from sail design to canvas work.",
    category_id: "sailmakers",
    category_name: "Sailmakers & Canvas",
    region_id: 18,
    region_name: "Whangarei",
    phone: "+64 9 438 1234",
    email: "info@northlandcanvas.co.nz",
    website: "https://www.northlandcanvas.co.nz/",
    services: ["Sail design","New sails","Sail repair","Canvas work","Cruising sails","Racing sails"],
    image_url: "https://www.northlandcanvas.co.nz/wp-content/uploads/2014/11/sails-specialists-northland.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 189,
    title: "North Sails Auckland",
    description: "The premier sailmaker for all racing and cruising sailboats. North Sails is the number one new sail choice for world-champion racers, superyachts, one-design sailboats, catamarans, trimarans, and casual cruisers. With global design technology and local expertise in Auckland, North Sails delivers sails engineered for performance, durability, and value.",
    category_id: "sailmakers",
    category_name: "Sailmakers & Canvas",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 570 1234",
    email: "info@northsails.co.nz",
    website: "https://www.northsails.com/pages/sailloft-auckland-new-zealand",
    services: ["Racing sails","Cruising sails","Superyacht sails","One-design sails","Sail repair","Sail design"],
    image_url: "https://www.northsails.com/cdn/shop/files/s-certifiedservice-sailrepair-cruising-1500x1500.jpg?v=1683209957&width=1920",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 190,
    title: "Doyle Sails New Zealand",
    description: "Leading sailmakers with a strong New Zealand presence. Doyle Sails combines world-class design technology with local craftsmanship to produce sails for cruising and racing yachts of all sizes. Their experienced team includes veteran sailmakers with Whitbread Round the World and America's Cup experience.",
    category_id: "sailmakers",
    category_name: "Sailmakers & Canvas",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 570 2345",
    email: "info@doylesails.co.nz",
    website: "https://www.doylesails.com/",
    services: ["Cruising sails","Racing sails","Sail repair","Sail design","Stratis membranes","Superyacht sails"],
    image_url: "https://www.doylesails.com/wp-content/uploads/2021/03/sailboat-sailing-boat-sea-1149519.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 191,
    title: "36° Brokers",
    description: "New Zealand's leading yacht brokerage, connecting buyers and sellers across NZ and the South Pacific. 36° Brokers specialises in powerboats, sailing yachts, and catamarans, representing world-class brands including Beneteau, Lagoon, and Excess Catamarans. Experienced team offers expert advice, tailored marketing, and seamless process from valuation through to settlement. Also offers boat finance and syndication.",
    category_id: "forsale",
    category_name: "Boats for Sale",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 963 0000",
    email: "info@36degrees.nz",
    website: "https://www.36degrees.nz/",
    services: ["New & used boat sales","Yacht brokerage","Catamaran sales","Boat finance","Syndication","Valuations"],
    image_url: "https://www.36degrees.nz/assets/Uploads/Excess-Catamaran-Sailing-Fun-NZ.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 192,
    title: "NZ Boat Sales",
    description: "Family-owned boutique boat brokerage with a 'boatique' approach. NZ Boat Sales lists launches, yachts, multihulls, charter, and commercial fishing vessels. NZ agents for Aquila, Seawind, Outremer, Garcia, Silent, and Allures Yachts. Brokers are passionate boaties themselves with many years of experience. Also offers unique reverse (Dutch) auction sales method.",
    category_id: "forsale",
    category_name: "Boats for Sale",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 27 548 0253",
    email: "info@nzboatsales.com",
    website: "https://www.nzboatsales.com/",
    services: ["New & used boats","Yacht sales","Catamaran sales","Reverse auctions","Boat valuations","Aquila & Seawind dealer"],
    image_url: "https://www.nzboatsales.com/wp-content/uploads/sites/131/2026/05/AssaultPursuit-8.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 193,
    title: "City of Sails Marine & NZ Boat Sales",
    description: "New Zealand's premier yacht brokers, covering Auckland, Northern Regions, and all points South. City of Sails Marine brings specialist knowledge and genuine passion for classics and the unique - the favourites and the special yachts and powerboats. Expert sales and valuations with personalised service for every vessel they represent.",
    category_id: "forsale",
    category_name: "Boats for Sale",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 27 248 3366",
    email: "info@cityofsailsmarine.co.nz",
    website: "https://www.cityofsailsmarine.co.nz/",
    services: ["Yacht brokerage","Powerboat sales","Classic yachts","Boat valuations","Nationwide service"],
    image_url: "https://static.wixstatic.com/media/b0568f_df1982e1f0554f399fdf67a326e63353%7Emv2.png/v1/fit/w_2500,h_1330,al_c/b0568f_df1982e1f0554f399fdf67a326e63353%7Emv2.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 194,
    title: "Vining Gulf Group",
    description: "Your go-to boat brokers for launches, powerboats, yachts, and marina berths. The Vining Gulf Group has locations across New Zealand including Waikawa (Picton), Nelson, Wellington, Christchurch, Auckland, Opua, and Whangarei. A long-established brokerage with extensive NZ-wide coverage and experienced brokers in every major boating region.",
    category_id: "forsale",
    category_name: "Boats for Sale",
    region_id: 9,
    region_name: "Marlborough",
    phone: "+64 3 573 7000",
    email: "info@viningmarine.co.nz",
    website: "https://viningmarine.co.nz/",
    services: ["Boat brokerage","Marina berth sales","Powerboats","Yachts","Nationwide coverage","Valuations"],
    image_url: "https://assets.cdn.filesafe.space/ZfuB4NFnSTcn598cl2HH/media/6a4435578882e8f6e37e500d.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 195,
    title: "The Yacht Sales Co.",
    description: "A major yacht brokerage with sales centres across New Zealand including Auckland and Whangarei. The Yacht Sales Co. offers a range of new and quality pre-owned yachts, representing leading international brands. Professional team with deep knowledge of the NZ and South Pacific market. Full sales, valuation, and advisory services.",
    category_id: "forsale",
    category_name: "Boats for Sale",
    region_id: 18,
    region_name: "Whangarei",
    phone: "+64 9 438 0000",
    email: "info@yachtsalesco.com",
    website: "https://yachtsalesco.com/",
    services: ["New yachts","Pre-owned yachts","Boat brokerage","Valuations","Advisory services","NZ & South Pacific"],
    image_url: "https://217790cc.delivery.rocketcdn.me/wp-content/uploads/2024/11/aura51.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 196,
    title: "Marine Hub NZ",
    description: "New Zealand's comprehensive marine marketplace for new and used boats for sale. Marine Hub lists yachts, trailer sailers, launches, trailer boats, jet skis, kayaks, and marina berths. Search by region across all of NZ - from Northland to Southland. Also features a marina directory and marine services guide.",
    category_id: "forsale",
    category_name: "Boats for Sale",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0100",
    email: "info@marinehub.co.nz",
    website: "https://www.marinehub.co.nz/",
    services: ["Boat listings","Yacht sales","Launches","Trailer boats","Jet skis","Marina berths"],
    image_url: "https://www.marinehub.co.nz/application/assets/images/MH-GulfGroup.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 197,
    title: "GOfuel",
    description: "New Zealand's marine fuel specialist. GOfuel supplies quality marine diesel and fuel to boats and vessels across NZ. Provides Mobil Diesel Efficient - an advanced fuel formulation engineered to lower carbon emissions and offer fuel savings, with an average 22% reduction in particulate matter and 10% NOx reduction. Online ordering available for convenient fuel supply.",
    category_id: "fuel",
    category_name: "Fuel & Bunkering",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0000",
    email: "orders@gofuel.co.nz",
    website: "https://www.gofuel.co.nz/",
    services: ["Marine diesel","Marine fuel supply","Mobil Diesel Efficient","Online ordering","NZ-wide delivery"],
    image_url: "https://marinelink.co.nz/images/listings/listing-197.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 198,
    title: "Hauraki Express Fuel",
    description: "Marine bunkering service on the Hauraki Gulf. Hauraki Express supplies quality diesel sourced from Gull New Zealand - always fresh and constantly monitored for quality and contamination. Professional bunkering service with environmental safety as a top priority. Also operates water taxi and fishing charter services from Kawau Bay.",
    category_id: "fuel",
    category_name: "Fuel & Bunkering",
    region_id: 1,
    region_name: "Auckland",
    phone: "0800 546 443",
    email: "info@haurakiexpress.co.nz",
    website: "https://haurakiexpress.co.nz/hauraki-express-fuel/",
    services: ["Marine bunkering","Diesel supply","Hauraki Gulf service","Quality fuel","Environmental safety"],
    image_url: "https://haurakiexpress.co.nz/app/uploads/2019/12/KBC-copy-768x576.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 199,
    title: "Dan-Bunkering New Zealand",
    description: "Global bunker fuel supplier servicing all major New Zealand ports including Auckland, Tauranga, Wellington, Nelson, and New Plymouth. Dan-Bunkering supplies Marine Gas Oil, Very Low Sulphur Fuel Oil, High Sulphur Fuel Oil, Ultra Low Sulphur Diesel, and Lube Oil. 24/7 service with over 50 years of local bunker and shipping experience.",
    category_id: "fuel",
    category_name: "Fuel & Bunkering",
    region_id: 1,
    region_name: "Auckland",
    phone: "+61 2 9247 2700",
    email: "nz@dan-bunkering.com",
    website: "https://dan-bunkering.com/ports/new-zealand/",
    services: ["Bunker fuel","Marine Gas Oil (MGO)","VLSFO","ULSD","Lube Oil","24/7 NZ port coverage"],
    image_url: "https://marinelink.co.nz/images/listings/listing-199.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 200,
    title: "ExxonMobil Marine NZ (Port of Tauranga)",
    description: "ExxonMobil Marine provides bunker fuel and marine lubricants at New Zealand ports including Port of Tauranga. Operates a dedicated marine fuelling vessel for efficient and safe bunkering. Through subsidiary Silver Fern Shipping, carries and distributes approximately 65% of New Zealand's liquid fuel products. Premium quality fuels with global technical support.",
    category_id: "fuel",
    category_name: "Fuel & Bunkering",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "+64 7 572 8000",
    email: "marine.nz@exxonmobil.com",
    website: "https://www.exxonmobil.com/en/marine",
    services: ["Marine fuel","Marine lubricants","Bunkering vessel","Port of Tauranga","Fuel quality assurance"],
    image_url: "https://marinelink.co.nz/images/listings/listing-200.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 201,
    title: "Westhaven Marina Fuel Dock",
    description: "Fuel dock facility at Westhaven Marina, New Zealand's largest marina. Located in the heart of Auckland's waterfront, the fuel dock provides diesel and petrol for recreational and commercial vessels. Easy access from the Hauraki Gulf, open extended hours during summer. Managed by Auckland Council Marinas.",
    category_id: "fuel",
    category_name: "Fuel & Bunkering",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 379 2000",
    email: "info@westhavenmarina.co.nz",
    website: "https://www.aucklandmarinas.com/",
    services: ["Diesel fuel","Petrol fuel","Fuel dock","Westhaven Marina","Extended summer hours"],
    image_url: "https://marinelink.co.nz/images/listings/listing-201.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 202,
    title: "Mariner Insurance",
    description: "New Zealand's favourite boat insurer, trusted by Kiwis for over a decade. Locally owned and operated with specialist cover for all types of boats and watercraft including yacht, trailer boat, launch, and jet ski insurance. Also offers blue water, construction, transit, and charter boat insurance. Over 2,000 positive reviews on Trustpilot with a 96% Excellent rating.",
    category_id: "insurance",
    category_name: "Marine Insurance",
    region_id: 1,
    region_name: "Auckland",
    phone: "0800 627 463",
    email: "info@mariner.co.nz",
    website: "https://www.mariner.co.nz/",
    services: ["Boat insurance","Yacht insurance","Trailer boat insurance","Jetski insurance","Blue water insurance","Charter boat insurance"],
    image_url: "https://www.datocms-assets.com/93388/1682697270-cover-mobile.jpg?w=960&q=35&auto=format",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 203,
    title: "Nautical Insurance",
    description: "Boat insurance made simple, established in 1988. Nautical Insurance specialises in trailered boats, jet skis, jet boats, and moored boats. With over 36 years of experience and 150+ years of combined team experience, Nautical provides fast and effective cover, efficient claims (under 24 hours), and specialised focus on NZ boat owner risks. 15,000+ claims handled.",
    category_id: "insurance",
    category_name: "Marine Insurance",
    region_id: 1,
    region_name: "Auckland",
    phone: "0508 628 8425",
    email: "info@nautical.co.nz",
    website: "https://nautical.co.nz/",
    services: ["Trailered boat insurance","Jet ski insurance","Jet boat insurance","Moored boat insurance","Fast claims","Specialist marine cover"],
    image_url: "https://marinelink.co.nz/images/listings/listing-203.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 204,
    title: "Bay Insurance Marine",
    description: "Specialist marine insurance providers for over 40 years, established 1979. Bay Insurance has developed a marine scheme providing cost-effective insurance cover tailored to boat owners' needs. Specialists in the marine industry with deep knowledge of local conditions and requirements across the Bay of Plenty and New Zealand.",
    category_id: "insurance",
    category_name: "Marine Insurance",
    region_id: 2,
    region_name: "Bay of Plenty",
    phone: "+64 7 577 1100",
    email: "info@bayinsurancemarine.co.nz",
    website: "https://www.bayinsurancemarine.co.nz/",
    services: ["Marine insurance","Boat insurance","Tailored cover","Cost-effective schemes","Bay of Plenty specialist"],
    image_url: "https://marinelink.co.nz/images/listings/listing-204.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 205,
    title: "PIC Insurance Brokers - Marine",
    description: "Expert marine insurance brokers providing comprehensive cover for boats and yachts. PIC Insurance Brokers offer specialist advice and tailored policies to protect your vessel. Independent brokers with access to multiple insurers, ensuring you get the best coverage at competitive rates. Full claims support and risk assessment services.",
    category_id: "insurance",
    category_name: "Marine Insurance",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 377 9700",
    email: "info@pic.co.nz",
    website: "https://www.pic.co.nz/marine-insurance/",
    services: ["Marine insurance","Boat insurance","Yacht insurance","Risk assessment","Claims support","Multi-insurer access"],
    image_url: "https://www.datocms-assets.com/105732/1702069216-marine_2023-11_rnzya-women-s-champs_d.jpg?auto=format&crop=focalpoint&fit=crop&fp-x=0.3&fp-y=0.39&h=650&w=1300",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 206,
    title: "Nautilus Marine Insurance",
    description: "For over 15 years, a specialist supplier of pleasurecraft and marine business assets and liability insurance. Nautilus Marine Insurance provides market-leading policies with broad coverage, strength of security, and support. Pleasure craft insurance offers great value, simple and easy coverage for boat owners across New Zealand.",
    category_id: "insurance",
    category_name: "Marine Insurance",
    region_id: 1,
    region_name: "Auckland",
    phone: "0800 628 842",
    email: "info@nminsurance.co.nz",
    website: "https://www.nminsurance.co.nz/our-brands/nautilus-marine-insurance/",
    services: ["Pleasurecraft insurance","Marine liability","Marine business assets","Broad coverage","Simple policies"],
    image_url: "https://marinelink.co.nz/images/listings/nautilus-marine-insurance-img.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 207,
    title: "Gallagher Marine Insurance",
    description: "One of New Zealand's largest insurance brokers, Gallagher maintains strong relationships with the Marina Operators Association and looks after many privately owned marinas throughout NZ. Negotiates competitive premiums with specialist marine insurers. Comprehensive marine insurance solutions for commercial and pleasure vessels, marine businesses, and marina operators.",
    category_id: "insurance",
    category_name: "Marine Insurance",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 377 9600",
    email: "info@ajg.co.nz",
    website: "https://www.ajg.co.nz/business/marine-insurance/",
    services: ["Marine insurance","Commercial marine","Pleasure craft","Marina operator cover","Competitive premiums","MOA partner"],
    image_url: "https://www.ajg.co.nz/assets/Uploads/videos/marine-v2__FocusFillWyIwLjAwIiwiMC4wMCIsNjkwLDUxMF0.PNG",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 208,
    title: "Coastguard Boating Education",
    description: "New Zealand's leading provider of recreational boating education, registered as a Private Training Establishment with NZQA. Coastguard Boating Education offers a huge range of courses including Day Skipper, Boatmaster, RYA/MCA Yachtmaster, and Sea Survival. Highly experienced and qualified tutors ensure the best learning experience. 4.5-star Google rating with 90% customer satisfaction.",
    category_id: "training",
    category_name: "Training & Courses",
    region_id: 1,
    region_name: "Auckland",
    phone: "0800 40 80 90",
    email: "info@boatingeducation.org.nz",
    website: "https://www.boatingeducation.org.nz/",
    services: ["Day Skipper","Boatmaster","RYA Yachtmaster","Sea Survival","VHF radio course","Online & classroom"],
    image_url: "https://www.boatingeducation.org.nz/images/w730/promos/Courses_near_you_-_HP.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 209,
    title: "Sail Nelson RYA Sailing School",
    description: "Registered RYA sailing school in the stunning Nelson region, adjacent to Abel Tasman National Park. Sail Nelson offers accredited RYA courses to suit all sailing skills and experience levels - from beginner to advanced. Passionate about giving you the skills and experience to enjoy sailing to the full. The Nelson region also offers world-class tramping, mountain biking, sea kayaking, and wine.",
    category_id: "training",
    category_name: "Training & Courses",
    region_id: 8,
    region_name: "Manawatū-Whanganui",
    phone: "+64 3 548 0000",
    email: "info@sailnelson.co.nz",
    website: "https://sailnelson.co.nz/",
    services: ["RYA sailing courses","Beginner to advanced","Practical sailing","Theory courses","Abel Tasman region","International qualifications"],
    image_url: "https://sailnelson.co.nz/wp-content/uploads/2018/05/sailing-school.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 210,
    title: "Powerboat Training NZ",
    description: "Niche specialist provider of RYA powerboat courses only. Dedicated instructors have achieved RYA Advanced and RYA Yachtmaster Power Instructor qualifications - the highest available. Chief Instructor is an RYA Trainer qualified to train instructors (only 6 in NZ). Offers the full range of RYA powerboat courses from beginner to advanced, including ICC tests for international certification.",
    category_id: "training",
    category_name: "Training & Courses",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0700",
    email: "info@powerboat-training.co.nz",
    website: "http://www.powerboat-training.co.nz/",
    services: ["RYA powerboat courses","Beginner to advanced","ICC tests","International certification","Yachtmaster Power","Specialist instructors"],
    image_url: "https://images.squarespace-cdn.com/content/64812bbe614bdc3272a07718/55dacdc1-4efb-4197-ba46-bbdbe5fdc8a2/Andrew.png?format=1500w&content-type=image%2Fpng",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 211,
    title: "New Zealand Maritime School",
    description: "Auckland's premier maritime training institution. NZ Maritime School develops specialist knowledge in safety of life at sea, safety of property, marine environment integrity, crew, cargo, and passengers. Offers Level 3 Superyacht Crewing - opening doors to exciting careers on luxury boats worldwide. Comprehensive maritime and seamanship education for commercial and recreational mariners.",
    category_id: "training",
    category_name: "Training & Courses",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 373 3000",
    email: "info@maritime.school.nz",
    website: "https://www.edumaritime.net/new-zealand/new-zealand-maritime-school-auckland",
    services: ["Maritime qualifications","Superyacht crewing","Commercial maritime","Safety training","Seamanship education","NZQA approved"],
    image_url: "https://marinelink.co.nz/images/listings/listing-211.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 212,
    title: "Great Escape Sailing School",
    description: "Bay of Islands' go-to for affordable sailing instruction, based at Opua Marina. Great Escape offers international qualifications from beginner courses to advanced flotilla adventures. Learn to sail on well-maintained kiwi-designed yachts from 20 to 31 feet, perfect for couples and small families. The sheltered waters of the Bay of Islands provide an ideal learning environment.",
    category_id: "training",
    category_name: "Training & Courses",
    region_id: 5,
    region_name: "Far North",
    phone: "+64 9 402 7143",
    email: "sail@greatescape.co.nz",
    website: "https://www.greatescape.co.nz/",
    services: ["Learn-to-sail courses","International qualifications","Sailing holidays","Flotilla adventures","Beginner friendly","Opua Marina departures"],
    image_url: "https://marinelink.co.nz/images/listings/listing-212.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 213,
    title: "NMIT Maritime Training",
    description: "Nelson Marlborough Institute of Technology provides approved maritime training for commercial seafarer certification. Offering a range of maritime qualifications from deckhand to watchkeeper and beyond. NMIT is an approved Maritime NZ training provider with experienced instructors and modern facilities. Pathway to careers in commercial shipping, fishing, and the maritime industry.",
    category_id: "training",
    category_name: "Training & Courses",
    region_id: 8,
    region_name: "Manawatū-Whanganui",
    phone: "+64 3 546 2477",
    email: "info@nmit.ac.nz",
    website: "https://www.nmit.ac.nz/",
    services: ["Commercial maritime training","Seafarer certification","Deckhand courses","Watchkeeper qualifications","Maritime NZ approved","Nelson campus"],
    image_url: "https://marinelink.co.nz/images/listings/listing-213.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 214,
    title: "NauticEd New Zealand",
    description: "Approved RYA Training Center delivering online and practical sailing courses worldwide. NauticEd offers the RYA Day Skipper Course and a full range of sailing certifications from beginner to advanced. With sailing schools across New Zealand, students can combine online theory with practical on-water training. Flexible, modern approach to sailing education.",
    category_id: "training",
    category_name: "Training & Courses",
    region_id: 1,
    region_name: "Auckland",
    phone: "",
    email: "info@nauticed.org",
    website: "https://www.nauticed.org/",
    services: ["Online sailing theory","RYA Day Skipper","Practical training","International certification","Flexible learning","NZ sailing schools"],
    image_url: "https://marinelink.co.nz/images/listings/listing-214.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 215,
    title: "Boat Haulage Ltd",
    description: "New Zealand's oldest and largest boat haulage company, offering nationwide transport for boats, tiny homes, and general cartage. Based at Beach Haven, Auckland, Boat Haulage provides transport, crane trucks, shrink wrapping, engineering, and shipping services. Decades of experience moving vessels of all sizes safely across New Zealand.",
    category_id: "transport",
    category_name: "Boat Transport",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 483 8111",
    email: "office@boathaulage.co.nz",
    website: "https://www.boathaulage.co.nz/",
    services: ["Boat transport","Nationwide haulage","Crane trucks","Shrink wrapping","Engineering","Shipping"],
    image_url: "https://www.boathaulage.co.nz/assets/boats/uteMercAndBoat.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 216,
    title: "Marine Haulage & Storage Ltd",
    description: "Family-owned and operated since 1989, with over 30 years of experience transporting and storing boats. Marine Haulage offers boat transport across town or across the country, long and short-term boat storage, heavy haulage, and load pilot services. Handles boats large and small with excellent service at affordable prices.",
    category_id: "transport",
    category_name: "Boat Transport",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0800",
    email: "info@marinehaulage.co.nz",
    website: "https://www.marinehaulage.co.nz/",
    services: ["Boat transport","Boat storage","Heavy haulage","Load pilot services","Nationwide","Long & short-term storage"],
    image_url: "https://static.wixstatic.com/media/3f328e_c0dd2fb3e8b74c9190e9fd6213f1c87b~mv2.png/v1/fill/w_707,h_294,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/MH%20Header%20image.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 217,
    title: "Exclusive Boat Haulage",
    description: "Boat movers for small to medium size craft, using a purpose-built boat hauling trailer to guarantee your pride and joy a safe and secure ride. Years of experience in moving boats, continuing the great service of previous owner and well-known boat mover Peter (PJ) Jacob. Reliable, careful, and professional boat transport across New Zealand.",
    category_id: "transport",
    category_name: "Boat Transport",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 27 470 0000",
    email: "info@exclusiveboathaulage.co.nz",
    website: "https://www.exclusiveboathaulage.co.nz/",
    services: ["Boat transport","Purpose-built trailer","Small to medium craft","Nationwide service","Safe & secure"],
    image_url: "https://assets.cdn.filesafe.space/DysiaNGdhs86ZI8I1t2x/media/68bea1ed6367da3ccca63e3a.png",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 218,
    title: "NZ Transport Services",
    description: "Boat and marine transport specialists, relocating boats, yachts, and marine vessels across New Zealand. NZTS assists with transporting your marine vessels with utmost care and expertise through an extensive network of specialised transport providers. Whether moving to a new marina, dock, or harbour, NZTS handles the logistics.",
    category_id: "transport",
    category_name: "Boat Transport",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 27 200 0000",
    email: "info@nztransportservices.co.nz",
    website: "https://nztransportservices.co.nz/",
    services: ["Boat transport","Marine transport","Marina relocations","Nationwide service","Specialised carriers","Logistics management"],
    image_url: "https://cdn.wisemove.co.nz/asset/image/carousel-boat-transport-nz.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 219,
    title: "Boat Minders Transport",
    description: "Taking the hassle out of transporting your boat with friendly, professional service that gets your assets to their destination on time and safely. Boat Minders also transports campervans, RVs, caravans, and Winnebagos anywhere in New Zealand. Comprehensive marine transport and vessel care services.",
    category_id: "transport",
    category_name: "Boat Transport",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0900",
    email: "info@boatminders.co.nz",
    website: "https://www.boatminders.co.nz/",
    services: ["Boat transport","Nationwide delivery","RV & caravan transport","Marine transport","Professional service"],
    image_url: "https://convertri.imgix.net/2584a160-56c5-11e6-829d-066a9bd5fb79/ed0b93b0764249e40c1ca930327df633630b8ee2/boat-towing-auckland.jpg?auto=compress,format&fit=scale&w=600",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
  {
    id: 220,
    title: "Bob's Transport Ltd",
    description: "Well-known and highly regarded as safe and reliable boat movers in New Zealand. Bob's Transport gets your boat there safely, whether you require boat haulage in Auckland or anywhere else in NZ. Run by the formidable team of Bob and Linda, they are trusted by boaties across the country for careful and professional trailer boat transport.",
    category_id: "transport",
    category_name: "Boat Transport",
    region_id: 1,
    region_name: "Auckland",
    phone: "+64 9 555 0650",
    email: "info@bobstransport.co.nz",
    website: "https://bobstransport.co.nz/",
    services: ["Trailer boat transport","Nationwide haulage","Auckland-based","Safe & reliable","Boat movers"],
    image_url: "https://bobstransport.co.nz/wp-content/uploads/2023/10/20230918_092603-scaled.jpg",
    badge: "new",
    rating: 0,
    reviews_count: 0,
  },
];

export const seedReviews: Review[] = [];
